export enum ListingResource {
  Property = 'Property',
  OpenHouse = 'OpenHouse',
  Media = 'Media',
  Unit = 'Unit',
  Room = 'Room',
  GreenVerification = 'GreenVerification',
}

export enum OpenHouseField {
  COUNTY = 'COUNTY',
  LISTING_ID = 'LISTING_ID',
  MLS_STATUS = 'MLS_STATUS',
  UOHVW_KEY = 'UOHVW_KEY',
  OPEN_HOUSE_ATTENDED_BY = 'OPEN_HOUSE_ATTENDED_BY',
  OPEN_HOUSE_CREATION_TIMESTAMP = 'OPEN_HOUSE_CREATION_TIMESTAMP',
  OPEN_HOUSE_DATE = 'OPEN_HOUSE_DATE',
  OPEN_HOUSE_END_TIME = 'OPEN_HOUSE_END_TIME',
  OPEN_HOUSE_ITEM_NUMBER = 'OPEN_HOUSE_ITEM_NUMBER',
  OPEN_HOUSE_KEY = 'OPEN_HOUSE_KEY',
  OPEN_HOUSE_LISTING_KEY = 'OPEN_HOUSE_LISTING_KEY',
  OPEN_HOUSE_MODIFICATION_TIMESTAMP = 'OPEN_HOUSE_MODIFICATION_TIMESTAMP',
  OPEN_HOUSE_SOURCE_BUSINESS_PARTNER = 'OPEN_HOUSE_SOURCE_BUSINESS_PARTNER',
  OPEN_HOUSE_SOURCE_INPUT = 'OPEN_HOUSE_SOURCE_INPUT',
  OPEN_HOUSE_REMARKS = 'OPEN_HOUSE_REMARKS',
  OPEN_HOUSE_SOURCE_TRANSPORT = 'OPEN_HOUSE_SOURCE_TRANSPORT',
  OPEN_HOUSE_SUB_SYSTEM_LOCALE = 'OPEN_HOUSE_SUB_SYSTEM_LOCALE',
  OPEN_HOUSE_SYSTEM_LOCALE = 'OPEN_HOUSE_SYSTEM_LOCALE',
  LISTING_SOURCE_RECORD_KEY = 'LISTING_SOURCE_RECORD_KEY',
  OPEN_HOUSE_EXTERNAL_SYSTEM_ID = 'OPEN_HOUSE_EXTERNAL_SYSTEM_ID',
  LIST_OFFICE_MLS_ID = 'LIST_OFFICE_MLS_ID',
  OPEN_HOUSE_START_TIME = 'OPEN_HOUSE_START_TIME',
  OPEN_HOUSE_TYPE = 'OPEN_HOUSE_TYPE',
  OPEN_HOUSE_METHOD = 'OPEN_HOUSE_METHOD',
  VIRTUAL_OPEN_HOUSE_URL = 'VIRTUAL_OPEN_HOUSE_URL',
}

export enum GreenVerificationField {
  GREEN_VERIFICATION_KEY = 'GREEN_VERIFICATION_KEY',
  GREEN_VERIFICATION_SYSTEM_LOCALE = 'GREEN_VERIFICATION_SYSTEM_LOCALE',
  GREEN_VERIFICATION_SUB_SYSTEM_LOCALE = 'GREEN_VERIFICATION_SUB_SYSTEM_LOCALE',
  GREEN_VERIFICATION_LISTING_KEY = 'GREEN_VERIFICATION_LISTING_KEY',
  GREEN_VERIFICATION_BODY = 'GREEN_VERIFICATION_BODY',
  GREEN_VERIFICATION_PROGRAM_TYPE = 'GREEN_VERIFICATION_PROGRAM_TYPE',
  GREEN_VERIFICATION_YEAR = 'GREEN_VERIFICATION_YEAR',
  GREEN_VERIFICATION_RATING = 'GREEN_VERIFICATION_RATING',
  GREEN_VERIFICATION_SCORE = 'GREEN_VERIFICATION_SCORE',
  GREEN_VERIFICATION_STATUS = 'GREEN_VERIFICATION_STATUS',
  COUNTY = 'COUNTY',
  LISTING_SOURCE_RECORD_KEY = 'LISTING_SOURCE_RECORD_KEY',
  GREEN_VERIFICATION_MODIFICATION_TIMESTAMP = 'GREEN_VERIFICATION_MODIFICATION_TIMESTAMP',
}

export enum MediaField {
  PROPERTY_TYPE = 'PROPERTY_TYPE',
  COUNTY = 'COUNTY',
  MEDIA_BYTES = 'MEDIA_BYTES',
  MEDIA_CATEGORY = 'MEDIA_CATEGORY',
  MEDIA_CREATION_TIMESTAMP = 'MEDIA_CREATION_TIMESTAMP',
  MEDIA_EXTERNAL_KEY = 'MEDIA_EXTERNAL_KEY',
  MEDIA_FILE_NAME = 'MEDIA_FILE_NAME',
  MEDIA_IMAGE_OF = 'MEDIA_IMAGE_OF',
  MEDIA_ITEM_NUMBER = 'MEDIA_ITEM_NUMBER',
  MEDIA_KEY = 'MEDIA_KEY',
  MED_VW_KEY = 'MED_VW_KEY',
  MEDIA_LONG_DESCRIPTION = 'MEDIA_LONG_DESCRIPTION',
  MEDIA_MODIFICATION_TIMESTAMP = 'MEDIA_MODIFICATION_TIMESTAMP',
  MEDIA_DISPLAY_ORDER = 'MEDIA_DISPLAY_ORDER',
  MEDIA_ORIGINAL_BYTES = 'MEDIA_ORIGINAL_BYTES',
  MEDIA_ORIGINAL_HEIGHT = 'MEDIA_ORIGINAL_HEIGHT',
  MEDIA_ORIGINAL_WIDTH = 'MEDIA_ORIGINAL_WIDTH',
  MEDIA_SHORT_DESCRIPTION = 'MEDIA_SHORT_DESCRIPTION',
  MEDIA_SIZE_DESCRIPTION = 'MEDIA_SIZE_DESCRIPTION',
  MEDIA_SOURCE_FILE_NAME = 'MEDIA_SOURCE_FILE_NAME',
  MEDIA_SUB_SYSTEM_LOCALE = 'MEDIA_SUB_SYSTEM_LOCALE',
  MEDIA_SYSTEM_LOCALE = 'MEDIA_SYSTEM_LOCALE',
  MEDIA_TYPE = 'MEDIA_TYPE',
  MEDIA_URL = 'MEDIA_URL',
  MEDIA_URL_FULL = 'MEDIA_URL_FULL',
  MEDIA_URLHD = 'MEDIA_URLHD',
  MEDIA_URL_HI_RES = 'MEDIA_URL_HI_RES',
  MEDIA_URL_MEDIUM = 'MEDIA_URL_MEDIUM',
  MEDIA_URL_THUMB = 'MEDIA_URL_THUMB',
  MLS_STATUS = 'MLS_STATUS',
  PREFERRED_PHOTO_YN = 'PREFERRED_PHOTO_YN',
  RESOURCE_NAME = 'RESOURCE_NAME',
  LISTING_ID = 'LISTING_ID',
  RESOURCE_RECORD_KEY = 'RESOURCE_RECORD_KEY',
  MEDIA_VENDOR_ID = 'MEDIA_VENDOR_ID',
  MEDIA_VENDOR_NAME = 'MEDIA_VENDOR_NAME',
  MEDIA_VENDOR_ID_TYPE = 'MEDIA_VENDOR_ID_TYPE',
  MEDIA_SOURCE_BUSINESS_PARTNER = 'MEDIA_SOURCE_BUSINESS_PARTNER',
  MEDIA_SOURCE_INPUT = 'MEDIA_SOURCE_INPUT',
  MEDIA_SOURCE_TRANSPORT = 'MEDIA_SOURCE_TRANSPORT',
  MEDIA_IMAGE_HEIGHT = 'MEDIA_IMAGE_HEIGHT',
  MEDIA_IMAGE_WIDTH = 'MEDIA_IMAGE_WIDTH',
  LISTING_SOURCE_RECORD_KEY = 'LISTING_SOURCE_RECORD_KEY',
  MEDIA_VISIBILITY = 'MEDIA_VISIBILITY',
  PROP_MEDIA_PROCESSING_STATUS = 'PROP_MEDIA_PROCESSING_STATUS',
  MEDIA_PROCESSING_STATUS = 'MEDIA_PROCESSING_STATUS',
  PROP_MEDIA_PENDING_FILE_NAME = 'PROP_MEDIA_PENDING_FILE_NAME',
  PROP_MEDIA_EXT_SYS_PROCESSING_CODE = 'PROP_MEDIA_EXT_SYS_PROCESSING_CODE',
  PROP_MEDIA_EXT_SYS_PROCESSING_TIME = 'PROP_MEDIA_EXT_SYS_PROCESSING_TIME',
  PROP_MEDIA_EXT_SYS_RESIZE_TIME = 'PROP_MEDIA_EXT_SYS_RESIZE_TIME',
  PROP_MEDIA_EXT_SYS_TOTAL_BYTES = 'PROP_MEDIA_EXT_SYS_TOTAL_BYTES',
  PROP_MEDIA_EXT_SYS_WRITE_TIME = 'PROP_MEDIA_EXT_SYS_WRITE_TIME',
  PROP_MEDIA_EXT_SYS_ERROR_MESSAGE = 'PROP_MEDIA_EXT_SYS_ERROR_MESSAGE',
  MEDIA_OBJECT_ID = 'MEDIA_OBJECT_ID',
  MEDIA_STATUS = 'MEDIA_STATUS',
  MEDIA_STATUS_DESCRIPTION = 'MEDIA_STATUS_DESCRIPTION',
}

export enum UnitField {
  COUNTY = 'COUNTY',
  UNIT_TYPE_KEY = 'UNIT_TYPE_KEY',
  UNIT_KEY = 'UNIT_KEY',
  UNIT_TYPE_LISTING_KEY = 'UNIT_TYPE_LISTING_KEY',
  UNITLIS_KEY = 'UNITLIS_KEY',
  UNIT_TYPE_ITEM_NUMBER = 'UNIT_TYPE_ITEM_NUMBER',
  UNIT_TYPE_TYPE = 'UNIT_TYPE_TYPE',
  UNIT_TYPE_MONTHLY_RENT = 'UNIT_TYPE_MONTHLY_RENT',
  UNIT_TYPE_PRO_FORMA = 'UNIT_TYPE_PRO_FORMA',
  UNIT_TYPE_OCCUPIED_YN = 'UNIT_TYPE_OCCUPIED_YN',
  UNIT_TYPE_LEVEL = 'UNIT_TYPE_LEVEL',
  UNIT_TYPE_FINISHED_SQFT = 'UNIT_TYPE_FINISHED_SQFT',
  UNIT_TYPE_LEASE_TYPE = 'UNIT_TYPE_LEASE_TYPE',
  UNIT_TYPE_LEASE_EXPIRATION_DATE = 'UNIT_TYPE_LEASE_EXPIRATION_DATE',
  UNIT_TYPE_BEDS_TOTAL = 'UNIT_TYPE_BEDS_TOTAL',
  UNIT_TYPE_BATHS_HALF = 'UNIT_TYPE_BATHS_HALF',
  UNIT_TYPE_BATHS_FULL = 'UNIT_TYPE_BATHS_FULL',
  UNIT_TYPE_BATHS_TOTAL = 'UNIT_TYPE_BATHS_TOTAL',
  UNIT_TYPE_FEATURES = 'UNIT_TYPE_FEATURES',
  UNIT_TYPE_TOTAL_ROOMS = 'UNIT_TYPE_TOTAL_ROOMS',
  UNIT_TYPE_CONTIGUOUS_SPACE_YN = 'UNIT_TYPE_CONTIGUOUS_SPACE_YN',
  UNIT_TYPE_SECURITY_DEPOSIT = 'UNIT_TYPE_SECURITY_DEPOSIT',
  LISTING_SOURCE_RECORD_KEY = 'LISTING_SOURCE_RECORD_KEY',
  PROP_UNIT_MODIFICATION_TIMESTAMP = 'PROP_UNIT_MODIFICATION_TIMESTAMP',
  UNIT_CHANGE_TIMESTAMP = 'UNIT_CHANGE_TIMESTAMP',
  UNIT_CHECK_OUT_TIMESTAMP = 'UNIT_CHECK_OUT_TIMESTAMP',
  UNIT_SYSTEM_LOCALE = 'UNIT_SYSTEM_LOCALE',
  UNIT_SUB_SYSTEM_LOCALE = 'UNIT_SUB_SYSTEM_LOCALE',
  UNIT_TYPE_SOURCE_RECORD_KEY = 'UNIT_TYPE_SOURCE_RECORD_KEY',
}

export enum RoomField {
  ROOM_KEY = 'ROOM_KEY',
  ROOM_LISTING_KEY = 'ROOM_LISTING_KEY',
  COUNTY = 'COUNTY',
  ROOM_TYPE = 'ROOM_TYPE',
  ROOM_LENGTH = 'ROOM_LENGTH',
  ROOM_WIDTH = 'ROOM_WIDTH',
  ROOM_LEVEL = 'ROOM_LEVEL',
  ROOM_EXISTS_YN = 'ROOM_EXISTS_YN',
  ROOM_DISPLAY_ORDER = 'ROOM_DISPLAY_ORDER',
  ROOM_ITEM_NUMBER = 'ROOM_ITEM_NUMBER',
  ROOM_AREA = 'ROOM_AREA',
  ROOM_DIMENSIONS = 'ROOM_DIMENSIONS',
  ROOM_FEATURES = 'ROOM_FEATURES',
  ROOM_FLOORING = 'ROOM_FLOORING',
  ROOM_SYSTEM_LOCALE = 'ROOM_SYSTEM_LOCALE',
  ROOM_SUB_SYSTEM_LOCALE = 'ROOM_SUB_SYSTEM_LOCALE',
  LISTING_SOURCE_RECORD_KEY = 'LISTING_SOURCE_RECORD_KEY',
  ROOM_MODIFICATION_TIMESTAMP = 'ROOM_MODIFICATION_TIMESTAMP',
  ROOM_DESCRIPTION = 'ROOM_DESCRIPTION',
  ROOM_SOURCE_RECORD_KEY = 'ROOM_SOURCE_RECORD_KEY',
}

export enum PropertyField {
  AI_REMARKS_TERMS_OF_USE = 'AI_REMARKS_TERMS_OF_USE',
  LISTING_KEY = 'LISTING_KEY',
  EDIT_KEY = 'LIS_KEY',
  LISTING_ID = 'LISTING_ID',
  LISTING_AGREEMENT_TYPE = 'LISTING_AGREEMENT_TYPE',
  LISTING_SERVICE_TYPE = 'LISTING_SERVICE_TYPE',
  MLS_STATUS = 'MLS_STATUS',
  STANDARD_STATUS = 'STANDARD_STATUS',
  OFFICE_EXCLUSIVE_YN = 'OFFICE_EXCLUSIVE_YN',
  OFFICE_EXCLUSIVE_TERM_DATE = 'OFFICE_EXCLUSIVE_TERM_DATE',
  OFFICE_EXCLUSIVE_TERMS_OF_USE = 'OFFICE_EXCLUSIVE_TERMS_OF_USE',
  COMPARABLE_YN = 'COMPARABLE_YN',
  DUPLICATE_LISTING_YN = 'DUPLICATE_LISTING_YN',
  DUPLICATE_SURVIVING_LISTING_KEY = 'DUPLICATE_SURVIVING_LISTING_KEY',
  DUPLICATE_MLS_IDS = 'DUPLICATE_MLS_IDS',
  CLIENT_APPLICATION_EDITED_YN = 'CLIENT_APPLICATION_EDITED_YN',
  SCHEDULED_SUBMISSION_ACTION = 'SCHEDULED_SUBMISSION_ACTION',
  COPIED_FROM_KEYS = 'COPIED_FROM_KEYS',
  CWA_KEY = 'CWA_KEY',
  LIST_PRICE = 'LIST_PRICE',
  LIST_PRICE_LOW = 'LIST_PRICE_LOW',
  ORIGINAL_LIST_PRICE = 'ORIGINAL_LIST_PRICE',
  PREVIOUS_LIST_PRICE = 'PREVIOUS_LIST_PRICE',
  CLOSE_PRICE = 'CLOSE_PRICE',
  CONCESSION_IN_PRICE_YN = 'CONCESSION_IN_PRICE_YN',
  CONCESSION_IN_PRICE_TYPE = 'CONCESSION_IN_PRICE_TYPE',
  CONCESSION_IN_PRICE_VALUE = 'CONCESSION_IN_PRICE_VALUE',
  PRICE_PER_SQUARE_FOOT = 'PRICE_PER_SQUARE_FOOT',
  CAM_PRICE_PER_SQUARE_FOOT_SQFT = 'CAM_PRICE_PER_SQUARE_FOOT_SQFT',
  ANNUAL_LEASE_PRICE_PER_SQUARE_FOOT = 'ANNUAL_LEASE_PRICE_PER_SQUARE_FOOT',
  CONTINGENT_DATE = 'CONTINGENT_DATE',
  PURCHASE_CONTRACT_DATE = 'PURCHASE_CONTRACT_DATE',
  CANCELATION_DATE = 'CANCELATION_DATE',
  PENDING_TIMESTAMP = 'PENDING_TIMESTAMP',
  CLOSE_DATE = 'CLOSE_DATE',
  EXPIRATION_DATE = 'EXPIRATION_DATE',
  WITHDRAWN_DATE = 'WITHDRAWN_DATE',
  STATUS_CHANGE_TIMESTAMP = 'STATUS_CHANGE_TIMESTAMP',
  PRICE_CHANGE_TIMESTAMP = 'PRICE_CHANGE_TIMESTAMP',
  MAJOR_CHANGE_TYPE = 'MAJOR_CHANGE_TYPE',
  MAJOR_CHANGE_TIMESTAMP = 'MAJOR_CHANGE_TIMESTAMP',
  ON_MARKET_DATE = 'ON_MARKET_DATE',
  ON_MARKET_TIMESTAMP = 'ON_MARKET_TIMESTAMP',
  OFF_MARKET_DATE = 'OFF_MARKET_DATE',
  OFF_MARKET_TIMESTAMP = 'OFF_MARKET_TIMESTAMP',
  DAYS_ON_MARKET = 'DAYS_ON_MARKET',
  CUMULATIVE_DAYS_ON_MARKET = 'CUMULATIVE_DAYS_ON_MARKET',
  DOM_PROPERTY_ACTIVE_YN = 'DOM_PROPERTY_ACTIVE_YN',
  DOM_PROPERTY_CALCULATED_DATE = 'DOM_PROPERTY_CALCULATED_DATE',
  PHOTOS_CHANGE_TIMESTAMP = 'PHOTOS_CHANGE_TIMESTAMP',
  LISTING_CONTRACT_DATE = 'LISTING_CONTRACT_DATE',
  ORIGINAL_ENTRY_TIMESTAMP = 'ORIGINAL_ENTRY_TIMESTAMP',
  MODIFICATION_TIMESTAMP = 'MODIFICATION_TIMESTAMP',
  SOURCE_MODIFICATION_TIMESTAMP = 'SOURCE_MODIFICATION_TIMESTAMP',
  MLS_LIST_DATE = 'MLS_LIST_DATE',
  BASE_OFF_MARKET_DATE = 'BASE_OFF_MARKET_DATE',
  CONTRACT_STATUS_CHANGE_DATE = 'CONTRACT_STATUS_CHANGE_DATE',
  BACK_TO_ACTIVE_DATE = 'BACK_TO_ACTIVE_DATE',
  DAYS_ON_COMING_SOON = 'DAYS_ON_COMING_SOON',
  EXPECTED_ON_MARKET_DATE = 'EXPECTED_ON_MARKET_DATE',
  AVAILABILITY_DATE = 'AVAILABILITY_DATE',
  PROPERTY_TYPE = 'PROPERTY_TYPE',
  PROPERTY_SUB_TYPE = 'PROPERTY_SUB_TYPE',
  STRUCTURE_DESIGN_TYPE = 'STRUCTURE_DESIGN_TYPE',
  LOT_SIZE_ACRES = 'LOT_SIZE_ACRES',
  LOT_SIZE_SQUARE_FEET = 'LOT_SIZE_SQUARE_FEET',
  LOT_SIZE_AREA = 'LOT_SIZE_AREA',
  LOT_SIZE_DIMENSIONS = 'LOT_SIZE_DIMENSIONS',
  LOT_SIZE_SOURCE = 'LOT_SIZE_SOURCE',
  LOT_SIZE_UNITS = 'LOT_SIZE_UNITS',
  LOT_FEATURES = 'LOT_FEATURES',
  CURRENT_USE = 'CURRENT_USE',
  POSSIBLE_USE = 'POSSIBLE_USE',
  BUILDING_AREA_TOTAL = 'BUILDING_AREA_TOTAL',
  BUILDING_AREA_UNITS = 'BUILDING_AREA_UNITS',
  LIVING_AREA = 'LIVING_AREA',
  LIVING_AREA_UNITS = 'LIVING_AREA_UNITS',
  ABOVE_GRADE_FINISHED_AREA = 'ABOVE_GRADE_FINISHED_AREA',
  ABOVE_GRADE_FINISHED_AREA_UNITS = 'ABOVE_GRADE_FINISHED_AREA_UNITS',
  BELOW_GRADE_FINISHED_AREA = 'BELOW_GRADE_FINISHED_AREA',
  BELOW_GRADE_FINISHED_AREA_UNITS = 'BELOW_GRADE_FINISHED_AREA_UNITS',
  LEASABLE_AREA = 'LEASABLE_AREA',
  LEASABLE_AREA_UNITS = 'LEASABLE_AREA_UNITS',
  YEAR_BUILT = 'YEAR_BUILT',
  YEAR_BUILT_SOURCE = 'YEAR_BUILT_SOURCE',
  YEAR_BUILT_EFFECTIVE = 'YEAR_BUILT_EFFECTIVE',
  STORIES = 'STORIES',
  STORIES_TOTAL = 'STORIES_TOTAL',
  UNIT_FLOORS = 'UNIT_FLOORS',
  BUILDER_NAME = 'BUILDER_NAME',
  BUILDER_MODEL = 'BUILDER_MODEL',
  ARCHITECT_NAME = 'ARCHITECT_NAME',
  NEW_CONSTRUCTION_YN = 'NEW_CONSTRUCTION_YN',
  CONSTRUCTION_COMPLETED_YN = 'CONSTRUCTION_COMPLETED_YN',
  CONSTRUCTION_MATERIALS = 'CONSTRUCTION_MATERIALS',
  FOUNDATION_DETAILS = 'FOUNDATION_DETAILS',
  FLOORING = 'FLOORING',
  ROOF = 'ROOF',
  BASEMENT = 'BASEMENT',
  BASEMENT_YN = 'BASEMENT_YN',
  COOLING_YN = 'COOLING_YN',
  COOLING = 'COOLING',
  HEATING_YN = 'HEATING_YN',
  HEATING = 'HEATING',
  APPLIANCES = 'APPLIANCES',
  INTERIOR_FEATURES = 'INTERIOR_FEATURES',
  EXTERIOR_FEATURES = 'EXTERIOR_FEATURES',
  PATIO_AND_PORCH_FEATURES = 'PATIO_AND_PORCH_FEATURES',
  WATER_SOURCE = 'WATER_SOURCE',
  WATER_BODY_NAME = 'WATER_BODY_NAME',
  WATER_BODY_TYPE = 'WATER_BODY_TYPE',
  WATERFRONT_YN = 'WATERFRONT_YN',
  POOL_PRIVATE_YN = 'POOL_PRIVATE_YN',
  POOL_FEATURES = 'POOL_FEATURES',
  SPA_YN = 'SPA_YN',
  SPA_FEATURES = 'SPA_FEATURES',
  VIEW_YN = 'VIEW_YN',
  VIEW = 'VIEW',
  LOT_DESCRIPTION = 'LOT_DESCRIPTION',
  LAND_LEASE_YN = 'LAND_LEASE_YN',
  OTHER_STRUCTURES = 'OTHER_STRUCTURES',
  ATTACHED_GARAGE_YN = 'ATTACHED_GARAGE_YN',
  CARPORT_YN = 'CARPORT_YN',
  FIREPLACE_YN = 'FIREPLACE_YN',
  FIREPLACES_TOTAL = 'FIREPLACES_TOTAL',
  FIREPLACE_FEATURES = 'FIREPLACE_FEATURES',
  FENCING_YN = 'FENCING_YN',
  FENCING = 'FENCING',
  FARM_FEATURES = 'FARM_FEATURES',
  SOIL_TYPES = 'SOIL_TYPES',
  CULTIVATED_AREA = 'CULTIVATED_AREA',
  CROPS = 'CROPS',
  IRRIGATION_SOURCE = 'IRRIGATION_SOURCE',
  IRRIGATION_WATER_RIGHTS_YN = 'IRRIGATION_WATER_RIGHTS_YN',
  IRRIGATION_WATER_RIGHTS_ACRES = 'IRRIGATION_WATER_RIGHTS_ACRES',
  ACCESSIBILITY_FEATURES = 'ACCESSIBILITY_FEATURES',
  ARCHITECTURAL_STYLE = 'ARCHITECTURAL_STYLE',
  BUILDING_CLASSIFICATION = 'BUILDING_CLASSIFICATION',
  BUILDING_NAME = 'BUILDING_NAME',
  BUILDING_FEATURES = 'BUILDING_FEATURES',
  COMMUNITY_FEATURES = 'COMMUNITY_FEATURES',
  DEVELOPMENT_STATUS = 'DEVELOPMENT_STATUS',
  GREEN_CERTIFICATION = 'GREEN_CERTIFICATION',
  GREEN_ENERGY_EFFICIENT = 'GREEN_ENERGY_EFFICIENT',
  GREEN_ENERGY_GENERATION = 'GREEN_ENERGY_GENERATION',
  GREEN_INDOOR_AIR_QUALITY = 'GREEN_INDOOR_AIR_QUALITY',
  GREEN_SUSTAINABILITY = 'GREEN_SUSTAINABILITY',
  GREEN_WATER_CONSERVATION = 'GREEN_WATER_CONSERVATION',
  GREEN_VERIFICATION_YN = 'GREEN_VERIFICATION_YN',
  COUNTRY = 'COUNTRY',
  STATE_OR_PROVINCE = 'STATE_OR_PROVINCE',
  COUNTY = 'COUNTY',
  CITY = 'CITY',
  POSTAL_CODE = 'POSTAL_CODE',
  POSTAL_CODE_PLUS4 = 'POSTAL_CODE_PLUS4',
  STREET_NUMBER = 'STREET_NUMBER',
  STREET_NUMBER_NUMERIC = 'STREET_NUMBER_NUMERIC',
  STREET_DIR_PREFIX = 'STREET_DIR_PREFIX',
  STREET_NAME = 'STREET_NAME',
  STREET_SUFFIX = 'STREET_SUFFIX',
  STREET_DIR_SUFFIX = 'STREET_DIR_SUFFIX',
  UNIT_NUMBER = 'UNIT_NUMBER',
  UNPARSED_ADDRESS = 'UNPARSED_ADDRESS',
  MLS_AREA_MAJOR = 'MLS_AREA_MAJOR',
  MLS_AREA_MINOR = 'MLS_AREA_MINOR',
  SUBDIVISION_NAME = 'SUBDIVISION_NAME',
  LATITUDE = 'LATITUDE',
  LONGITUDE = 'LONGITUDE',
  DIRECTIONS = 'DIRECTIONS',
  ELEMENTARY_SCHOOL = 'ELEMENTARY_SCHOOL',
  MIDDLE_OR_JUNIOR_SCHOOL = 'MIDDLE_OR_JUNIOR_SCHOOL',
  HIGH_SCHOOL = 'HIGH_SCHOOL',
  SCHOOL_DISTRICT_SOURCE = 'SCHOOL_DISTRICT_SOURCE',
  CROSS_STREET = 'CROSS_STREET',
  MAP_URL = 'MAP_URL',
  FULL_STREET_ADDRESS = 'FULL_STREET_ADDRESS',
  STREET_NAME_AND_SUFFIX = 'STREET_NAME_AND_SUFFIX',
  LOCATION = 'LOCATION',
  LISTING_LOCALE = 'LISTING_LOCALE',
  IN_CITY_LIMITS_YN = 'IN_CITY_LIMITS_YN',
  PUBLIC_REMARKS = 'PUBLIC_REMARKS',
  SYNDICATION_REMARKS = 'SYNDICATION_REMARKS',
  PRIVATE_REMARKS = 'PRIVATE_REMARKS',
  PRIVATE_OFFICE_REMARKS = 'PRIVATE_OFFICE_REMARKS',
  BROKER_REMARKS = 'BROKER_REMARKS',
  DISCLOSURES = 'DISCLOSURES',
  EXCLUSIONS = 'EXCLUSIONS',
  INCLUSIONS = 'INCLUSIONS',
  LISTING_TERMS = 'LISTING_TERMS',
  SPECIAL_LISTING_CONDITIONS = 'SPECIAL_LISTING_CONDITIONS',
  OWNERSHIP_INTEREST = 'OWNERSHIP_INTEREST',
  CONTINGENCY = 'CONTINGENCY',
  CONCESSIONS = 'CONCESSIONS',
  POSSESSION = 'POSSESSION',
  CURRENT_LEASE_AMOUNT = 'CURRENT_LEASE_AMOUNT',
  CURRENT_LEASE_EXPIRATION = 'CURRENT_LEASE_EXPIRATION',
  CURRENT_LEASE_TYPE = 'CURRENT_LEASE_TYPE',
  ENVIRONMENTAL_HAZARDS = 'ENVIRONMENTAL_HAZARDS',
  HOME_WARRANTY_YN = 'HOME_WARRANTY_YN',
  LISTING_AGREEMENT = 'LISTING_AGREEMENT',
  LISTING_SERVICE = 'LISTING_SERVICE',
  LOCK_BOX_LOCATION = 'LOCK_BOX_LOCATION',
  LOCK_BOX_TYPE = 'LOCK_BOX_TYPE',
  LOCK_BOX_SERIAL_NUMBER = 'LOCK_BOX_SERIAL_NUMBER',
  SHOWING = 'SHOWING',
  SPECIAL_NOTES = 'SPECIAL_NOTES',
  VIRTUAL_TOUR_URL_UNBRANDED = 'VIRTUAL_TOUR_URL_UNBRANDED',
  DOCUMENTS_AVAILABLE = 'DOCUMENTS_AVAILABLE',
  EARNEST_MONEY = 'EARNEST_MONEY',
  PROSPECTS_EXCLUDED_YN = 'PROSPECTS_EXCLUDED_YN',
  SHOWING_INSTRUCTIONS = 'SHOWING_INSTRUCTIONS',
  SIGN_ON_PROPERTY_YN = 'SIGN_ON_PROPERTY_YN',
  TERMS_OF_LEASE = 'TERMS_OF_LEASE',
  VACATION_RENTAL_YN = 'VACATION_RENTAL_YN',
  INTERNET_ADDRESS_DISPLAY_YN = 'INTERNET_ADDRESS_DISPLAY_YN',
  INTERNET_AUTOMATED_VALUATION_DISPLAY_YN = 'INTERNET_AUTOMATED_VALUATION_DISPLAY_YN',
  INTERNET_CONSUMER_COMMENT_YN = 'INTERNET_CONSUMER_COMMENT_YN',
  INTERNET_ENTIRE_LISTING_DISPLAY_YN = 'INTERNET_ENTIRE_LISTING_DISPLAY_YN',
  SYNDICATE_TO_OPTION = 'SYNDICATE_TO_OPTION',
  SYNDICATE_TO = 'SYNDICATE_TO',
  VOW_AVM_YN = 'VOW_AVM_YN',
  VOW_ADDR_YN = 'VOW_ADDR_YN',
  VOW_COMMENT_YN = 'VOW_COMMENT_YN',
  VOW_LIST_YN = 'VOW_LIST_YN',
  CAP_RATE = 'CAP_RATE',
  GROSS_INCOME = 'GROSS_INCOME',
  NET_OPERATING_INCOME = 'NET_OPERATING_INCOME',
  OPERATING_EXPENSE = 'OPERATING_EXPENSE',
  TAX_ANNUAL_AMOUNT = 'TAX_ANNUAL_AMOUNT',
  TAX_YEAR = 'TAX_YEAR',
  TAX_ASSESSMENT_AMOUNT = 'TAX_ASSESSMENT_AMOUNT',
  ASSOCIATION_FEE = 'ASSOCIATION_FEE',
  ASSOCIATION_FEE_FREQUENCY = 'ASSOCIATION_FEE_FREQUENCY',
  ASSOCIATION_NAME = 'ASSOCIATION_NAME',
  CABLE_TV_EXPENSE = 'CABLE_TV_EXPENSE',
  ELECTRIC_EXPENSE = 'ELECTRIC_EXPENSE',
  GAS_EXPENSE = 'GAS_EXPENSE',
  INSURANCE_EXPENSE = 'INSURANCE_EXPENSE',
  LEASE_AMOUNT = 'LEASE_AMOUNT',
  MAINTENANCE_EXPENSE = 'MAINTENANCE_EXPENSE',
  MANAGEMENT_EXPENSE = 'MANAGEMENT_EXPENSE',
  POOL_EXPENSE = 'POOL_EXPENSE',
  WATER_SEWER_EXPENSE = 'WATER_SEWER_EXPENSE',
  TOTAL_EXPENSE = 'TOTAL_EXPENSE',
  GROSS_SCHEDULED_INCOME = 'GROSS_SCHEDULED_INCOME',
  VACANCY_ALLOWANCE = 'VACANCY_ALLOWANCE',
  OTHER_INCOME = 'OTHER_INCOME',
  ANNUAL_NET_OPERATING_INCOME = 'ANNUAL_NET_OPERATING_INCOME',
  CAPITALIZATION_RATE = 'CAPITALIZATION_RATE',
  TOTAL_ACTUAL_RENT = 'TOTAL_ACTUAL_RENT',
  VACANCY_ALLOWANCE_RATE = 'VACANCY_ALLOWANCE_RATE',
  INCOME_INCLUDES = 'INCOME_INCLUDES',
  EXPENSE_INCLUDES = 'EXPENSE_INCLUDES',
  NUMBER_OF_UNITS_LEASED = 'NUMBER_OF_UNITS_LEASED',
  NUMBER_OF_UNITS_VACANT = 'NUMBER_OF_UNITS_VACANT',
  RENT_CONTROL_YN = 'RENT_CONTROL_YN',
  TENANT_PAYS = 'TENANT_PAYS',
  OWNER_PAYS = 'OWNER_PAYS',
  CAP_RATE_PRO_FORMA = 'CAP_RATE_PRO_FORMA',
  GROSS_RENT_MULTIPLIER = 'GROSS_RENT_MULTIPLIER',
  INCOME_POTENTIAL = 'INCOME_POTENTIAL',
  PROFIT_AND_LOSS_STATEMENT = 'PROFIT_AND_LOSS_STATEMENT',
  RENT_INCLUDES = 'RENT_INCLUDES',
  CAP_VALUE_GROUND_RENT = 'CAP_VALUE_GROUND_RENT',
  COMMON_AREA_MAINTENANCE = 'COMMON_AREA_MAINTENANCE',
  GROUND_RENT_AMOUNT = 'GROUND_RENT_AMOUNT',
  GROUND_RENT_PAYMENT_FREQUENCY = 'GROUND_RENT_PAYMENT_FREQUENCY',
  GROUND_RENT_YRS_LEFT = 'GROUND_RENT_YRS_LEFT',
  GROUND_RENT_EXISTS_YN = 'GROUND_RENT_EXISTS_YN',
  LIST_AGENT_KEY = 'LIST_AGENT_KEY',
  LIST_AGENT_FULL_NAME = 'LIST_AGENT_FULL_NAME',
  LIST_AGENT_EMAIL = 'LIST_AGENT_EMAIL',
  LIST_AGENT_MLS_ID = 'LIST_AGENT_MLS_ID',
  LIST_AGENT_PHONE = 'LIST_AGENT_PHONE',
  LIST_OFFICE_KEY = 'LIST_OFFICE_KEY',
  LIST_OFFICE_NAME = 'LIST_OFFICE_NAME',
  LIST_OFFICE_PHONE = 'LIST_OFFICE_PHONE',
  LIST_OFFICE_MLS_ID = 'LIST_OFFICE_MLS_ID',
  CO_LIST_AGENT_KEY = 'CO_LIST_AGENT_KEY',
  CO_LIST_AGENT_FULL_NAME = 'CO_LIST_AGENT_FULL_NAME',
  CO_LIST_AGENT_EMAIL = 'CO_LIST_AGENT_EMAIL',
  CO_LIST_AGENT_MLS_ID = 'CO_LIST_AGENT_MLS_ID',
  CO_LIST_AGENT_PHONE = 'CO_LIST_AGENT_PHONE',
  CO_LIST_OFFICE_KEY = 'CO_LIST_OFFICE_KEY',
  CO_LIST_OFFICE_NAME = 'CO_LIST_OFFICE_NAME',
  CO_LIST_OFFICE_PHONE = 'CO_LIST_OFFICE_PHONE',
  CO_LIST_OFFICE_MLS_ID = 'CO_LIST_OFFICE_MLS_ID',
  BUYER_AGENT_KEY = 'BUYER_AGENT_KEY',
  BUYER_AGENT_FULL_NAME = 'BUYER_AGENT_FULL_NAME',
  BUYER_AGENT_EMAIL = 'BUYER_AGENT_EMAIL',
  BUYER_AGENT_MLS_ID = 'BUYER_AGENT_MLS_ID',
  BUYER_AGENT_PHONE = 'BUYER_AGENT_PHONE',
  BUYER_OFFICE_KEY = 'BUYER_OFFICE_KEY',
  BUYER_OFFICE_NAME = 'BUYER_OFFICE_NAME',
  BUYER_OFFICE_PHONE = 'BUYER_OFFICE_PHONE',
  BUYER_OFFICE_MLS_ID = 'BUYER_OFFICE_MLS_ID',
  CO_BUYER_AGENT_KEY = 'CO_BUYER_AGENT_KEY',
  CO_BUYER_AGENT_FULL_NAME = 'CO_BUYER_AGENT_FULL_NAME',
  CO_BUYER_AGENT_EMAIL = 'CO_BUYER_AGENT_EMAIL',
  CO_BUYER_AGENT_MLS_ID = 'CO_BUYER_AGENT_MLS_ID',
  CO_BUYER_AGENT_PHONE = 'CO_BUYER_AGENT_PHONE',
  CO_BUYER_OFFICE_KEY = 'CO_BUYER_OFFICE_KEY',
  CO_BUYER_OFFICE_NAME = 'CO_BUYER_OFFICE_NAME',
  CO_BUYER_OFFICE_PHONE = 'CO_BUYER_OFFICE_PHONE',
  CO_BUYER_OFFICE_MLS_ID = 'CO_BUYER_OFFICE_MLS_ID',
  PHOTOS_COUNT = 'PHOTOS_COUNT',
  DOCUMENTS_CHANGE_TIMESTAMP = 'DOCUMENTS_CHANGE_TIMESTAMP',
  DOCUMENTS_COUNT = 'DOCUMENTS_COUNT',
  VIDEO_URL_UNBRANDED = 'VIDEO_URL_UNBRANDED',
  SOUND_URL = 'SOUND_URL',
  LIST_PICTURE2_URL = 'LIST_PICTURE2_URL',
  LIST_PICTURE3_URL = 'LIST_PICTURE3_URL',
  LIST_PICTURE_URL = 'LIST_PICTURE_URL',
  PHOTO_KEY = 'PHOTO_KEY',
  PHOTO_OPTION = 'PHOTO_OPTION',
  TOTAL_PHOTOS = 'TOTAL_PHOTOS',
  LIS_MEDIA_LIST = 'LIS_MEDIA_LIST',
  MEDIA_BY = 'MEDIA_BY',
  BUSINESS_NAME = 'BUSINESS_NAME',
  BUSINESS_TYPE = 'BUSINESS_TYPE',
  YEAR_ESTABLISHED = 'YEAR_ESTABLISHED',
  NUMBER_OF_FULL_TIME_EMPLOYEES = 'NUMBER_OF_FULL_TIME_EMPLOYEES',
  NUMBER_OF_PART_TIME_EMPLOYEES = 'NUMBER_OF_PART_TIME_EMPLOYEES',
  HOURS_OF_OPERATION = 'HOURS_OF_OPERATION',
  DAYS_OF_OPERATION = 'DAYS_OF_OPERATION',
  ANNUAL_SALES = 'ANNUAL_SALES',
  INVENTORY_DESCRIPTION = 'INVENTORY_DESCRIPTION',
  INVENTORY_VALUE = 'INVENTORY_VALUE',
  NUMBER_OF_LICENSES = 'NUMBER_OF_LICENSES',
  LEASE_TERM = 'LEASE_TERM',
  FURNITURE = 'FURNITURE',
  FIXTURES = 'FIXTURES',
  EQUIPMENT = 'EQUIPMENT',
  PRESENT_LICENSES = 'PRESENT_LICENSES',
  PETS_ALLOWED = 'PETS_ALLOWED',
  PETS_ALLOWED_YN = 'PETS_ALLOWED_YN',
  FURNISHED_YN = 'FURNISHED_YN',
  LEASE_CONSIDERED_YN = 'LEASE_CONSIDERED_YN',
  APPLICATION_FEE = 'APPLICATION_FEE',
  MOVE_IN_AMOUNT = 'MOVE_IN_AMOUNT',
  MOVE_IN_DATE = 'MOVE_IN_DATE',
  LEASE_AMOUNT_FREQUENCY = 'LEASE_AMOUNT_FREQUENCY',
  LEASE_TYPE = 'LEASE_TYPE',
  LEASE_EXPIRATION = 'LEASE_EXPIRATION',
  SECURITY_DEPOSIT = 'SECURITY_DEPOSIT',
  LAST_MONTH_RENT_YN = 'LAST_MONTH_RENT_YN',
  RENT_TO_OWN_YN = 'RENT_TO_OWN_YN',
  SECTION8_YN = 'SECTION8_YN',
  SECTION8_APPROVED = 'SECTION8_APPROVED',
  PET_DEPOSIT = 'PET_DEPOSIT',
  MONTHLY_PET_RENT = 'MONTHLY_PET_RENT',
  MOVE_IN_FEE = 'MOVE_IN_FEE',
  SMOKING_ALLOWED_YN = 'SMOKING_ALLOWED_YN',
  ELECTRIC = 'ELECTRIC',
  GAS = 'GAS',
  SEWER = 'SEWER',
  WATER = 'WATER',
  CABLE_AVAILABLE_YN = 'CABLE_AVAILABLE_YN',
  INTERNET_AVAILABLE_YN = 'INTERNET_AVAILABLE_YN',
  NATURAL_GAS_AVAILABLE_YN = 'NATURAL_GAS_AVAILABLE_YN',
  ELECTRIC_ON_PROPERTY_YN = 'ELECTRIC_ON_PROPERTY_YN',
  NUMBER_OF_SEPARATE_ELECTRIC_METERS = 'NUMBER_OF_SEPARATE_ELECTRIC_METERS',
  NUMBER_OF_SEPARATE_GAS_METERS = 'NUMBER_OF_SEPARATE_GAS_METERS',
  NUMBER_OF_SEPARATE_WATER_METERS = 'NUMBER_OF_SEPARATE_WATER_METERS',
  UTILITIES = 'UTILITIES',
  METERING = 'METERING',
  ASSOCIATION_YN = 'ASSOCIATION_YN',
  ASSOCIATION_FEE_INCLUDES = 'ASSOCIATION_FEE_INCLUDES',
  ASSOCIATION_AMENITIES = 'ASSOCIATION_AMENITIES',
  ASSOCIATION_NAME2 = 'ASSOCIATION_NAME2',
  ASSOCIATION_FEE2 = 'ASSOCIATION_FEE2',
  ASSOCIATION_FEE2_FREQUENCY = 'ASSOCIATION_FEE2_FREQUENCY',
  ASSOCIATION_MANAGEMENT_TYPE = 'ASSOCIATION_MANAGEMENT_TYPE',
  COMMUNITY_RULES = 'COMMUNITY_RULES',
  FARM_LAND_AREA_TOTAL = 'FARM_LAND_AREA_TOTAL',
  CROP_TYPES = 'CROP_TYPES',
  GRAZING = 'GRAZING',
  TILLABLE_AREA = 'TILLABLE_AREA',
  PASTURE_AREA = 'PASTURE_AREA',
  FENCED_AREA = 'FENCED_AREA',
  RANGE_AREA = 'RANGE_AREA',
  CROPS_INCLUDED_YN = 'CROPS_INCLUDED_YN',
  FARM_CREDIT_SERVICE_INCL_YN = 'FARM_CREDIT_SERVICE_INCL_YN',
  FARM_LAND_AREA_SOURCE = 'FARM_LAND_AREA_SOURCE',
  FARM_LAND_AREA_UNITS = 'FARM_LAND_AREA_UNITS',
  FARM_OPERATION = 'FARM_OPERATION',
  FARM_REMARKS = 'FARM_REMARKS',
  WATER_ACCESS_YN = 'WATER_ACCESS_YN',
  WATER_VIEW_YN = 'WATER_VIEW_YN',
  WATERFRONT_FEATURES = 'WATERFRONT_FEATURES',
  DOCK_TYPE = 'DOCK_TYPE',
  SLIPS = 'SLIPS',
  DISTANCE_TO_BODY_OF_WATER = 'DISTANCE_TO_BODY_OF_WATER',
  DISTANCE_TO_BODY_OF_WATER_UNITS = 'DISTANCE_TO_BODY_OF_WATER_UNITS',
  DISTANCE_TO_BODY_OF_WATER_REMARKS = 'DISTANCE_TO_BODY_OF_WATER_REMARKS',
  DOCK_SLIP_CONVEYANCE = 'DOCK_SLIP_CONVEYANCE',
  NAVIGABLE_WATER_YN = 'NAVIGABLE_WATER_YN',
  RIPARIAN_RIGHTS_YN = 'RIPARIAN_RIGHTS_YN',
  WATER_ACCESS_FEATURES = 'WATER_ACCESS_FEATURES',
  WATER_FRONTAGE_IN_FEET = 'WATER_FRONTAGE_IN_FEET',
  WATER_ORIENTED_YN = 'WATER_ORIENTED_YN',
  PARKING_TOTAL = 'PARKING_TOTAL',
  GARAGE_YN = 'GARAGE_YN',
  GARAGE_SPACES = 'GARAGE_SPACES',
  CARPORT_SPACES = 'CARPORT_SPACES',
  COVERED_SPACES = 'COVERED_SPACES',
  OPEN_PARKING = 'OPEN_PARKING',
  PARKING_FEATURES = 'PARKING_FEATURES',
  PARKING_TYPES = 'PARKING_TYPES',
  GARAGE_TYPE = 'GARAGE_TYPE',
  NUM_PARKING_SPACES = 'NUM_PARKING_SPACES',
  NUM_DETACHED_GARAGE_SPACES = 'NUM_DETACHED_GARAGE_SPACES',
  NUM_ATTACHED_GARAGE_SPACES = 'NUM_ATTACHED_GARAGE_SPACES',
  NUM_ATTACHED_CARPORT_SPACES = 'NUM_ATTACHED_CARPORT_SPACES',
  NUM_DETACHED_CARPORT_SPACES = 'NUM_DETACHED_CARPORT_SPACES',
  NUM_PARKING_GARAGE_SPACES = 'NUM_PARKING_GARAGE_SPACES',
  NUM_TRUCK_TRAILER_PARKING_SPACES = 'NUM_TRUCK_TRAILER_PARKING_SPACES',
  NUM_CAR_PARKING_SPACES = 'NUM_CAR_PARKING_SPACES',
  TOTAL_GARAGE_AND_PARKING_SPACES = 'TOTAL_GARAGE_AND_PARKING_SPACES',
  ASSIGNED_PARKING_SPACES = 'ASSIGNED_PARKING_SPACES',
  ASSIGNED_PARKING_SPACE_NUMBER = 'ASSIGNED_PARKING_SPACE_NUMBER',
  NUM_DRIVEWAY_SPACES = 'NUM_DRIVEWAY_SPACES',
  NUM_PARKING_LOT_SPACES = 'NUM_PARKING_LOT_SPACES',
  NUM_OFF_SITE_SPACES = 'NUM_OFF_SITE_SPACES',
  NUM_OFF_STREET_SPACES = 'NUM_OFF_STREET_SPACES',
  BEDROOMS_TOTAL = 'BEDROOMS_TOTAL',
  BATHROOMS_TOTAL_INTEGER = 'BATHROOMS_TOTAL_INTEGER',
  BATHROOMS_FULL = 'BATHROOMS_FULL',
  BATHROOMS_HALF = 'BATHROOMS_HALF',
  FULL_BATHS_LOWER = 'FULL_BATHS_LOWER',
  FULL_BATHS_MAIN = 'FULL_BATHS_MAIN',
  FULL_BATHS_UPPER = 'FULL_BATHS_UPPER',
  LAUNDRY_LOWER = 'LAUNDRY_LOWER',
  LAUNDRY_ON_MAIN = 'LAUNDRY_ON_MAIN',
  LAUNDRY_UPPER = 'LAUNDRY_UPPER',
  LAUNDRY_TOTAL = 'LAUNDRY_TOTAL',
  ROOMS_TOTAL = 'ROOMS_TOTAL',
  ROOM_LIST = 'ROOM_LIST',
  LOWER_LEVELS_TOTAL_BATHS = 'LOWER_LEVELS_TOTAL_BATHS',
  LOWER_LEVELS_TOTAL_BEDROOMS = 'LOWER_LEVELS_TOTAL_BEDROOMS',
  LOWER_LEVELS_TOTAL_FULL_BATHS = 'LOWER_LEVELS_TOTAL_FULL_BATHS',
  LOWER_LEVELS_TOTAL_HALF_BATHS = 'LOWER_LEVELS_TOTAL_HALF_BATHS',
  UPPER_LEVELS_TOTAL_BATHS = 'UPPER_LEVELS_TOTAL_BATHS',
  UPPER_LEVELS_TOTAL_BEDROOMS = 'UPPER_LEVELS_TOTAL_BEDROOMS',
  UPPER_LEVELS_TOTAL_FULL_BATHS = 'UPPER_LEVELS_TOTAL_FULL_BATHS',
  UPPER_LEVELS_TOTAL_HALF_BATHS = 'UPPER_LEVELS_TOTAL_HALF_BATHS',
  MAIN_LEVEL_BEDROOMS = 'MAIN_LEVEL_BEDROOMS',
  MAIN_LEVEL_FULL_BATHS = 'MAIN_LEVEL_FULL_BATHS',
  MAIN_LEVEL_HALF_BATHS = 'MAIN_LEVEL_HALF_BATHS',
  MAIN_FLOOR_BEDROOMS = 'MAIN_FLOOR_BEDROOMS',
  BEDS_ON_MAIN = 'BEDS_ON_MAIN',
  HALF_BATHS_MAIN = 'HALF_BATHS_MAIN',
  HALF_BATHS_UPPER = 'HALF_BATHS_UPPER',
  HALF_BATHS_LOWER = 'HALF_BATHS_LOWER',
  MAIN_FLOOR_BATHS = 'MAIN_FLOOR_BATHS',
  MAIN_LEVEL_TOTAL_BATHS = 'MAIN_LEVEL_TOTAL_BATHS',
  LOAD = 'LOAD',
  BEDROOM_PERCS = 'BEDROOM_PERCS',
  DUAL_AGENCY_YN = 'DUAL_AGENCY_YN',
  AUCTION_BUYER_PREMIUM = 'AUCTION_BUYER_PREMIUM',
  OFFER_MANAGEMENT_PROVIDER = 'OFFER_MANAGEMENT_PROVIDER',
  OFFER_MANAGEMENT_URL = 'OFFER_MANAGEMENT_URL',
  AUCTION_BUYER_PREMIUM_TYPE = 'AUCTION_BUYER_PREMIUM_TYPE',
  AUCTION_END_DATE = 'AUCTION_END_DATE',
  AUCTION_LOCATION = 'AUCTION_LOCATION',
  AUCTION_PREVIEW_1_END_DATE = 'AUCTION_PREVIEW_1_END_DATE',
  AUCTION_PREVIEW_1_START_DATE = 'AUCTION_PREVIEW_1_START_DATE',
  AUCTION_PUBLISHED_MIN_BID = 'AUCTION_PUBLISHED_MIN_BID',
  AUCTION_REGISTRATION_DEADLINE = 'AUCTION_REGISTRATION_DEADLINE',
  AUCTION_REGISTRATION_URL = 'AUCTION_REGISTRATION_URL',
  AUCTION_START_DATE = 'AUCTION_START_DATE',
  AUCTION_TERMS_URL = 'AUCTION_TERMS_URL',
  AUCTION_TIME = 'AUCTION_TIME',
  AUCTION_TYPE = 'AUCTION_TYPE',
  ON_SITE_PHONE = 'ON_SITE_PHONE',
  PROPERTY_RELATIONSHIP_LIST = 'PROPERTY_RELATIONSHIP_LIST',
  LISTING_SOURCE_RECORD_ID = 'LISTING_SOURCE_RECORD_ID',
  LISTING_SOURCE_RECORD_KEY = 'LISTING_SOURCE_RECORD_KEY',
  LISTING_SOURCE_BUSINESS_PARTNER = 'LISTING_SOURCE_BUSINESS_PARTNER',
  SYSTEM_LOCALE = 'SYSTEM_LOCALE',
  SUB_SYSTEM_LOCALE = 'SUB_SYSTEM_LOCALE',
  TOTAL_BROKER_OPEN_HOUSES = 'TOTAL_BROKER_OPEN_HOUSES',
  TOTAL_OPEN_HOUSES = 'TOTAL_OPEN_HOUSES',
  TOTAL_PUBLIC_OPEN_HOUSES = 'TOTAL_PUBLIC_OPEN_HOUSES',
  TOTAL_SHOWINGS = 'TOTAL_SHOWINGS',
  TOTAL_TAXES_PAYMENT_FREQUENCY = 'TOTAL_TAXES_PAYMENT_FREQUENCY',
  TOTAL_VIRTUAL_TOURS = 'TOTAL_VIRTUAL_TOURS',
  LISTING_SOURCE_TRANSPORT = 'LISTING_SOURCE_TRANSPORT',
  LISTING_SOURCE_INPUT = 'LISTING_SOURCE_INPUT',
  MUNICIPAL_INSPECTIONS_YN = 'MUNICIPAL_INSPECTIONS_YN',
  LIST_AGENT_BRIGHT_CONVERTED_YN = 'LIST_AGENT_BRIGHT_CONVERTED_YN',
  LIST_OFFICE_BRIGHT_CONVERTED_YN = 'LIST_OFFICE_BRIGHT_CONVERTED_YN',
  ONE_BEDROOM_UNITS = 'ONE_BEDROOM_UNITS',
  THREE_BEDROOM_UNITS = 'THREE_BEDROOM_UNITS',
  TWO_BEDROOM_UNITS = 'TWO_BEDROOM_UNITS',
  USE_COPIED_PHOTO = 'USE_COPIED_PHOTO',
  SINGLE_ROOM_UNITS = 'SINGLE_ROOM_UNITS',
  OPEN_HOUSE_LIST = 'OPEN_HOUSE_LIST',
  PROFESSIONAL_RELATIONSHIP_LIST = 'PROFESSIONAL_RELATIONSHIP_LIST',
  COMING_SOON_ELIGIBILITY_DAYS = 'COMING_SOON_ELIGIBILITY_DAYS',
  LOSS_MITIGATION_FEE_YN = 'LOSS_MITIGATION_FEE_YN',
  CLOSE_AGENCY_TYPE = 'CLOSE_AGENCY_TYPE',
  ACCEPTABLE_FINANCING = 'ACCEPTABLE_FINANCING',
  SHOWING_HUB_HOST_URL = 'SHOWING_HUB_HOST_URL',
  SHOWING_HUB_REGISTRATION_ID = 'SHOWING_HUB_REGISTRATION_ID',
  SHOWING_HUB_APPLICATION_ID = 'SHOWING_HUB_APPLICATION_ID',
  SHOWING_PROVIDER = 'SHOWING_PROVIDER',
  BUYER_AGENT_CELL_PHONE = 'BUYER_AGENT_CELL_PHONE',
  BUYER_AGENT_DIRECT_PHONE = 'BUYER_AGENT_DIRECT_PHONE',
  SOURCE_BUYER_TEAM_NAME = 'SOURCE_BUYER_TEAM_NAME',
  BUYER_AGENT_FAX = 'BUYER_AGENT_FAX',
  BUYER_AGENT_FIRST_NAME = 'BUYER_AGENT_FIRST_NAME',
  BUYER_AGENT_LAST_NAME = 'BUYER_AGENT_LAST_NAME',
  BUYER_AGENT_NAME_SUFFIX = 'BUYER_AGENT_NAME_SUFFIX',
  BUYER_AGENT_OFFICE_PHONE = 'BUYER_AGENT_OFFICE_PHONE',
  BUYER_AGENT_OFFICE_PHONE_EXT = 'BUYER_AGENT_OFFICE_PHONE_EXT',
  BUYER_AGENT_PREFERRED_PHONE = 'BUYER_AGENT_PREFERRED_PHONE',
  BUYER_AGENT_PREFERRED_PHONE_EXT = 'BUYER_AGENT_PREFERRED_PHONE_EXT',
  BUYER_AGENT_AOR = 'BUYER_AGENT_AOR',
  BUYER_AGENT_NAME_PREFIX = 'BUYER_AGENT_NAME_PREFIX',
  BUYER_AGENT_URL = 'BUYER_AGENT_URL',
  BUYER_AGENT_VOICE_MAIL = 'BUYER_AGENT_VOICE_MAIL',
  BUYER_AGENT_VOICE_MAIL_EXT = 'BUYER_AGENT_VOICE_MAIL_EXT',
  BUYER_AGENT_STATE_LICENSE_NUMBER = 'BUYER_AGENT_STATE_LICENSE_NUMBER',
  BUYER_AGENT_TEAM_KEY = 'BUYER_AGENT_TEAM_KEY',
  BUYER_AGENT_TEAM_LEAD_AGENT_KEY = 'BUYER_AGENT_TEAM_LEAD_AGENT_KEY',
  BUYER_AGENT_TEAM_LEAD_STATE_LICENSE_NUMBER = 'BUYER_AGENT_TEAM_LEAD_STATE_LICENSE_NUMBER',
  BUYER_AGENT_TEAM_NAME = 'BUYER_AGENT_TEAM_NAME',
  BUYER_AGENT_TEAM_LEAD_AGENT_NAME = 'BUYER_AGENT_TEAM_LEAD_AGENT_NAME',
  SELLER_PAID_REPAIRS_IMPROVEMENTS = 'SELLER_PAID_REPAIRS_IMPROVEMENTS',
  SELLER_PAID_FINANCE_RELATED_COSTS = 'SELLER_PAID_FINANCE_RELATED_COSTS',
  SELLER_PAID_OTHER_CLOSING_COSTS = 'SELLER_PAID_OTHER_CLOSING_COSTS',
  SELLER_PAID_CLOSING_COSTS_TOTAL = 'SELLER_PAID_CLOSING_COSTS_TOTAL',
  BUYER_OFFICE_EMAIL = 'BUYER_OFFICE_EMAIL',
  BUYER_OFFICE_FAX = 'BUYER_OFFICE_FAX',
  BUYER_OFFICE_PHONE_EXT = 'BUYER_OFFICE_PHONE_EXT',
  BUYER_OFFICE_AOR = 'BUYER_OFFICE_AOR',
  BUYER_OFFICE_URL = 'BUYER_OFFICE_URL',
  BUYER_OFFICE_BROKER_OF_RECORD_ID = 'BUYER_OFFICE_BROKER_OF_RECORD_ID',
  BUYER_OFFICE_BROKER_OF_RECORD_KEY = 'BUYER_OFFICE_BROKER_OF_RECORD_KEY',
  BUYER_OFFICE_DISTANCE = 'BUYER_OFFICE_DISTANCE',
  BUYER_OFFICE_RESPONSIBLE_BROKER_KEY = 'BUYER_OFFICE_RESPONSIBLE_BROKER_KEY',
  BUYER_OFFICE_RESPONSIBLE_BROKER_LICENSE_NUMBER = 'BUYER_OFFICE_RESPONSIBLE_BROKER_LICENSE_NUMBER',
  CO_BUYER_AGENT_CELL_PHONE = 'CO_BUYER_AGENT_CELL_PHONE',
  CO_BUYER_AGENT_DIRECT_PHONE = 'CO_BUYER_AGENT_DIRECT_PHONE',
  CO_BUYER_AGENT_FAX = 'CO_BUYER_AGENT_FAX',
  CO_BUYER_AGENT_FIRST_NAME = 'CO_BUYER_AGENT_FIRST_NAME',
  CO_BUYER_AGENT_LAST_NAME = 'CO_BUYER_AGENT_LAST_NAME',
  CO_BUYER_AGENT_NAME_SUFFIX = 'CO_BUYER_AGENT_NAME_SUFFIX',
  CO_BUYER_AGENT_OFFICE_PHONE = 'CO_BUYER_AGENT_OFFICE_PHONE',
  CO_BUYER_AGENT_OFFICE_PHONE_EXT = 'CO_BUYER_AGENT_OFFICE_PHONE_EXT',
  CO_BUYER_AGENT_PREFERRED_PHONE = 'CO_BUYER_AGENT_PREFERRED_PHONE',
  CO_BUYER_AGENT_PREFERRED_PHONE_EXT = 'CO_BUYER_AGENT_PREFERRED_PHONE_EXT',
  CO_BUYER_AGENT_AOR = 'CO_BUYER_AGENT_AOR',
  CO_BUYER_AGENT_NAME_PREFIX = 'CO_BUYER_AGENT_NAME_PREFIX',
  CO_BUYER_AGENT_URL = 'CO_BUYER_AGENT_URL',
  CO_BUYER_AGENT_VOICE_MAIL = 'CO_BUYER_AGENT_VOICE_MAIL',
  CO_BUYER_AGENT_VOICE_MAIL_EXT = 'CO_BUYER_AGENT_VOICE_MAIL_EXT',
  CO_BUYER_AGENT_STATE_LICENSE_NUMBER = 'CO_BUYER_AGENT_STATE_LICENSE_NUMBER',
  CO_BUYER_AGENT_TEAM_KEY = 'CO_BUYER_AGENT_TEAM_KEY',
  CO_BUYER_AGENT_TEAM_LEAD_AGENT_KEY = 'CO_BUYER_AGENT_TEAM_LEAD_AGENT_KEY',
  CO_BUYER_AGENT_TEAM_LEAD_STATE_LICENSE_NUMBER = 'CO_BUYER_AGENT_TEAM_LEAD_STATE_LICENSE_NUMBER',
  CO_BUYER_AGENT_TEAM_NAME = 'CO_BUYER_AGENT_TEAM_NAME',
  CO_BUYER_AGENT_TEAM_LEAD_AGENT_NAME = 'CO_BUYER_AGENT_TEAM_LEAD_AGENT_NAME',
  ASSOCIATION_PHONE = 'ASSOCIATION_PHONE',
  ASSOCIATION_PHONE_2 = 'ASSOCIATION_PHONE_2',
  CONDO_YN = 'CONDO_YN',
  ELEVATOR_USE_FEE = 'ELEVATOR_USE_FEE',
  MANAGEMENT_ALT_PHONE = 'MANAGEMENT_ALT_PHONE',
  MANAGEMENT_FAX = 'MANAGEMENT_FAX',
  MANAGEMENT_PHONE = 'MANAGEMENT_PHONE',
  NON_POWER_BOATS_PERMITTED = 'NON_POWER_BOATS_PERMITTED',
  NUMBER_OF_COMMUNITY_SLIPS = 'NUMBER_OF_COMMUNITY_SLIPS',
  NUMBER_OF_COMMUNITY_DOCKS = 'NUMBER_OF_COMMUNITY_DOCKS',
  PHYSICAL_DOCK_SLIP_CONVEYS_YN = 'PHYSICAL_DOCK_SLIP_CONVEYS_YN',
  POWER_BOATS_PERMITTED = 'POWER_BOATS_PERMITTED',
  PROPERTY_MANAGER_YN = 'PROPERTY_MANAGER_YN',
  PROPERTY_MANAGER_FIRST_NAME = 'PROPERTY_MANAGER_FIRST_NAME',
  PROPERTY_MANAGER_LAST_NAME = 'PROPERTY_MANAGER_LAST_NAME',
  PROPERTY_MANAGMENT_COMPANY = 'PROPERTY_MANAGMENT_COMPANY',
  CAPITAL_CONTRIBUTION_FEE = 'CAPITAL_CONTRIBUTION_FEE',
  OTHER_FEES = 'OTHER_FEES',
  OTHER_FEES_FREQUENCY = 'OTHER_FEES_FREQUENCY',
  ADDITIONAL_ASSOCIATION_FEES = 'ADDITIONAL_ASSOCIATION_FEES',
  ASSOCIATION_RECREATION_FEE_YN = 'ASSOCIATION_RECREATION_FEE_YN',
  ASSOCIATION_RECREATION_FEE = 'ASSOCIATION_RECREATION_FEE',
  TRANSPORTATION = 'TRANSPORTATION',
  CO_BUYER_OFFICE_EMAIL = 'CO_BUYER_OFFICE_EMAIL',
  CO_BUYER_OFFICE_FAX = 'CO_BUYER_OFFICE_FAX',
  CO_BUYER_OFFICE_PHONE_EXT = 'CO_BUYER_OFFICE_PHONE_EXT',
  CO_BUYER_OFFICE_AOR = 'CO_BUYER_OFFICE_AOR',
  CO_BUYER_OFFICE_URL = 'CO_BUYER_OFFICE_URL',
  CITY_ID = 'CITY_ID',
  INCORPORATED_CITY_NAME = 'INCORPORATED_CITY_NAME',
  STREET_SUFFIX_MODIFIER = 'STREET_SUFFIX_MODIFIER',
  VALIDATION_STATUS = 'VALIDATION_STATUS',
  TRAFFIC_COUNT = 'TRAFFIC_COUNT',
  CO_LIST_AGENT_CELL_PHONE = 'CO_LIST_AGENT_CELL_PHONE',
  CO_LIST_AGENT_DIRECT_PHONE = 'CO_LIST_AGENT_DIRECT_PHONE',
  CO_LIST_AGENT_FAX = 'CO_LIST_AGENT_FAX',
  CO_LIST_AGENT_FIRST_NAME = 'CO_LIST_AGENT_FIRST_NAME',
  CO_LIST_AGENT_LAST_NAME = 'CO_LIST_AGENT_LAST_NAME',
  CO_LIST_AGENT_NAME_SUFFIX = 'CO_LIST_AGENT_NAME_SUFFIX',
  CO_LIST_AGENT_OFFICE_PHONE = 'CO_LIST_AGENT_OFFICE_PHONE',
  CO_LIST_AGENT_OFFICE_PHONE_EXT = 'CO_LIST_AGENT_OFFICE_PHONE_EXT',
  CO_LIST_AGENT_PREFERRED_PHONE = 'CO_LIST_AGENT_PREFERRED_PHONE',
  CO_LIST_AGENT_PREFERRED_PHONE_EXT = 'CO_LIST_AGENT_PREFERRED_PHONE_EXT',
  CO_LIST_AGENT_AOR = 'CO_LIST_AGENT_AOR',
  CO_LIST_AGENT_NAME_PREFIX = 'CO_LIST_AGENT_NAME_PREFIX',
  CO_LIST_AGENT_URL = 'CO_LIST_AGENT_URL',
  CO_LIST_AGENT_VOICE_MAIL = 'CO_LIST_AGENT_VOICE_MAIL',
  CO_LIST_AGENT_VOICE_MAIL_EXT = 'CO_LIST_AGENT_VOICE_MAIL_EXT',
  CO_LIST_AGENT_STATE_LICENSE_NUMBER = 'CO_LIST_AGENT_STATE_LICENSE_NUMBER',
  CO_LIST_AGENT_TEAM_KEY = 'CO_LIST_AGENT_TEAM_KEY',
  CO_LIST_AGENT_TEAM_LEAD_AGENT_KEY = 'CO_LIST_AGENT_TEAM_LEAD_AGENT_KEY',
  CO_LIST_AGENT_TEAM_LEAD_STATE_LICENSE_NUMBER = 'CO_LIST_AGENT_TEAM_LEAD_STATE_LICENSE_NUMBER',
  CO_LIST_AGENT_TEAM_NAME = 'CO_LIST_AGENT_TEAM_NAME',
  CO_LIST_AGENT_TEAM_LEAD_AGENT_NAME = 'CO_LIST_AGENT_TEAM_LEAD_AGENT_NAME',
  SUSSEX_DE_QUADRANTS = 'SUSSEX_DE_QUADRANTS',
  LEGAL_SUBDIVISION = 'LEGAL_SUBDIVISION',
  CO_LIST_OFFICE_EMAIL = 'CO_LIST_OFFICE_EMAIL',
  CO_LIST_OFFICE_FAX = 'CO_LIST_OFFICE_FAX',
  CO_LIST_OFFICE_PHONE_EXT = 'CO_LIST_OFFICE_PHONE_EXT',
  CO_LIST_OFFICE_AOR = 'CO_LIST_OFFICE_AOR',
  CO_LIST_OFFICE_URL = 'CO_LIST_OFFICE_URL',
  OC_CROSS_STREET = 'OC_CROSS_STREET',
  BUYER_FINANCING = 'BUYER_FINANCING',
  CONCESSIONS_SUBSIDY = 'CONCESSIONS_SUBSIDY',
  CONCESSIONS_RECIPIENT = 'CONCESSIONS_RECIPIENT',
  CONCESSION_REMARKS = 'CONCESSION_REMARKS',
  LAST_CONTINGENCY_EXPIRES = 'LAST_CONTINGENCY_EXPIRES',
  KICK_OUT_CLAUSE_YN = 'KICK_OUT_CLAUSE_YN',
  NUM_DAYS_IN_KICK_OUT_CLAUSE = 'NUM_DAYS_IN_KICK_OUT_CLAUSE',
  CONTINGENCY_LIST = 'CONTINGENCY_LIST',
  AUTOMATICALLY_CLOSE_ON_CLOSE_DATE_YN = 'AUTOMATICALLY_CLOSE_ON_CLOSE_DATE_YN',
  LIST_AGENT_CELL_PHONE = 'LIST_AGENT_CELL_PHONE',
  LIST_AGENT_DIRECT_PHONE = 'LIST_AGENT_DIRECT_PHONE',
  SOURCE_LIST_TEAM_NAME = 'SOURCE_LIST_TEAM_NAME',
  LIST_AGENT_FAX = 'LIST_AGENT_FAX',
  LIST_AGENT_FIRST_NAME = 'LIST_AGENT_FIRST_NAME',
  LIST_AGENT_LAST_NAME = 'LIST_AGENT_LAST_NAME',
  LIST_AGENT_NAME_SUFFIX = 'LIST_AGENT_NAME_SUFFIX',
  LIST_AGENT_OFFICE_PHONE = 'LIST_AGENT_OFFICE_PHONE',
  LIST_AGENT_OFFICE_PHONE_EXT = 'LIST_AGENT_OFFICE_PHONE_EXT',
  LIST_AGENT_PREFERRED_PHONE = 'LIST_AGENT_PREFERRED_PHONE',
  LIST_AGENT_PREFERRED_PHONE_EXT = 'LIST_AGENT_PREFERRED_PHONE_EXT',
  LIST_AGENT_AOR = 'LIST_AGENT_AOR',
  LIST_AGENT_NAME_PREFIX = 'LIST_AGENT_NAME_PREFIX',
  LIST_AGENT_URL = 'LIST_AGENT_URL',
  LIST_AGENT_VOICE_MAIL = 'LIST_AGENT_VOICE_MAIL',
  LIST_AGENT_VOICE_MAIL_EXT = 'LIST_AGENT_VOICE_MAIL_EXT',
  LIST_AGENT_RATE_PLUG_YN = 'LIST_AGENT_RATE_PLUG_YN',
  LIST_AGENT_STATE_LICENSE_NUMBER = 'LIST_AGENT_STATE_LICENSE_NUMBER',
  LIST_AGENT_TEAM_KEY = 'LIST_AGENT_TEAM_KEY',
  LIST_AGENT_TEAM_LEAD_AGENT_KEY = 'LIST_AGENT_TEAM_LEAD_AGENT_KEY',
  LIST_AGENT_TEAM_LEAD_STATE_LICENSE_NUMBER = 'LIST_AGENT_TEAM_LEAD_STATE_LICENSE_NUMBER',
  LIST_AGENT_TEAM_NAME = 'LIST_AGENT_TEAM_NAME',
  LIST_AGENT_TEAM_LEAD_AGENT_NAME = 'LIST_AGENT_TEAM_LEAD_AGENT_NAME',
  BUYER_AGENCY_COMPENSATION_TYPE = 'BUYER_AGENCY_COMPENSATION_TYPE',
  BUYER_AGENCY_COMPENSATION = 'BUYER_AGENCY_COMPENSATION',
  SUB_AGENCY_ADDITIONAL_COMPENSATION = 'SUB_AGENCY_ADDITIONAL_COMPENSATION',
  SUB_AGENCY_COMPENSATION = 'SUB_AGENCY_COMPENSATION',
  SUB_AGENCY_COMPENSATION_TYPE = 'SUB_AGENCY_COMPENSATION_TYPE',
  TRANSACTION_BROKER_COMPENSATION = 'TRANSACTION_BROKER_COMPENSATION',
  TRANSACTION_BROKER_COMPENSATION_TYPE = 'TRANSACTION_BROKER_COMPENSATION_TYPE',
  DUAL_VARIABLE_COMPENSATION_YN = 'DUAL_VARIABLE_COMPENSATION_YN',
  LEASE_RENEWAL_COMPENSATION = 'LEASE_RENEWAL_COMPENSATION',
  COMPENSATION_LIST = 'COMPENSATION_LIST',
  BUYER_AGENCY_COMPENSATION_2 = 'BUYER_AGENCY_COMPENSATION_2',
  BUYER_AGENCY_COMPENSATION_2_TYPE = 'BUYER_AGENCY_COMPENSATION_2_TYPE',
  SUB_AGENCY_COMPENSATION_2 = 'SUB_AGENCY_COMPENSATION_2',
  SUB_AGENCY_COMPENSATION_2_TYPE = 'SUB_AGENCY_COMPENSATION_2_TYPE',
  TRANSACTION_BROKER_COMPENSATION_2 = 'TRANSACTION_BROKER_COMPENSATION_2',
  TRANSACTION_BROKER_COMPENSATION_2_TYPE = 'TRANSACTION_BROKER_COMPENSATION_2_TYPE',
  TRANSACTION_BROKER_COMPENSATION_SELECTION = 'TRANSACTION_BROKER_COMPENSATION_SELECTION',
  BUYER_AGENCY_COMPENSATION_SELECTION = 'BUYER_AGENCY_COMPENSATION_SELECTION',
  SUB_AGENCY_COMPENSATION_SELECTION = 'SUB_AGENCY_COMPENSATION_SELECTION',
  LIST_OFFICE_EMAIL = 'LIST_OFFICE_EMAIL',
  LIST_OFFICE_FAX = 'LIST_OFFICE_FAX',
  LIST_OFFICE_PHONE_EXT = 'LIST_OFFICE_PHONE_EXT',
  LIST_OFFICE_AOR = 'LIST_OFFICE_AOR',
  LIST_OFFICE_URL = 'LIST_OFFICE_URL',
  LIST_OFFICE_BROKER_OF_RECORD_ID = 'LIST_OFFICE_BROKER_OF_RECORD_ID',
  LIST_OFFICE_BROKER_OF_RECORD_KEY = 'LIST_OFFICE_BROKER_OF_RECORD_KEY',
  LIST_OFFICE_DISTANCE = 'LIST_OFFICE_DISTANCE',
  LIST_OFFICE_COUNTY = 'LIST_OFFICE_COUNTY',
  LIST_OFFICE_RESPONSIBLE_BROKER_KEY = 'LIST_OFFICE_RESPONSIBLE_BROKER_KEY',
  LIST_OFFICE_RESPONSIBLE_BROKER_LICENSE_NUMBER = 'LIST_OFFICE_RESPONSIBLE_BROKER_LICENSE_NUMBER',
  AUTO_POPULATE_SCHOOLS_YN = 'AUTO_POPULATE_SCHOOLS_YN',
  ELEMENTARY_SCHOOL_SOURCE = 'ELEMENTARY_SCHOOL_SOURCE',
  HIGH_SCHOOL_SOURCE = 'HIGH_SCHOOL_SOURCE',
  MIDDLE_SCHOOL_SOURCE = 'MIDDLE_SCHOOL_SOURCE',
  SCHOOL_DISTRICT_NAME = 'SCHOOL_DISTRICT_NAME',
  SCHOOL_DISTRICT_KEY = 'SCHOOL_DISTRICT_KEY',
  BELOW_GRADE_FINISHED_AREA_SOURCE = 'BELOW_GRADE_FINISHED_AREA_SOURCE',
  SKIRT = 'SKIRT',
  DEPT_OF_HOUSING_DECAL_1 = 'DEPT_OF_HOUSING_DECAL_1',
  DEPT_OF_HOUSING_DECAL_2 = 'DEPT_OF_HOUSING_DECAL_2',
  DEPT_OF_HOUSING_DECAL_3 = 'DEPT_OF_HOUSING_DECAL_3',
  DOOR_FEATURES = 'DOOR_FEATURES',
  ENTRY_LEVEL = 'ENTRY_LEVEL',
  ENTRY_LOCATION = 'ENTRY_LOCATION',
  DIRECTION_FACES = 'DIRECTION_FACES',
  ABOVE_GRADE_FINISHED_AREA_SOURCE = 'ABOVE_GRADE_FINISHED_AREA_SOURCE',
  BUILDING_AREA_SOURCE = 'BUILDING_AREA_SOURCE',
  LIVING_AREA_SOURCE = 'LIVING_AREA_SOURCE',
  LICENSE_1 = 'LICENSE_1',
  LICENSE_2 = 'LICENSE_2',
  LICENSE_3 = 'LICENSE_3',
  MAKE = 'MAKE',
  MODEL = 'MODEL',
  LIS_BUILDER_MODEL = 'LIS_BUILDER_MODEL',
  OPEN_PARKING_YN = 'OPEN_PARKING_YN',
  OPEN_PARKING_SPACES = 'OPEN_PARKING_SPACES',
  PROPERTY_ATTACHED_YN = 'PROPERTY_ATTACHED_YN',
  COMMON_WALLS = 'COMMON_WALLS',
  SERIAL_U = 'SERIAL_U',
  SERIAL_X = 'SERIAL_X',
  SERIAL_XX = 'SERIAL_XX',
  LEVELS = 'LEVELS',
  BODY_TYPE = 'BODY_TYPE',
  HABITABLE_RESIDENCE_YN = 'HABITABLE_RESIDENCE_YN',
  WALLS_CEILINGS = 'WALLS_CEILINGS',
  WINDOW_FEATURES = 'WINDOW_FEATURES',
  WALK_SCORE = 'WALK_SCORE',
  MOBILE_DIM_UNITS = 'MOBILE_DIM_UNITS',
  MOBILE_LENGTH = 'MOBILE_LENGTH',
  MOBILE_WIDTH = 'MOBILE_WIDTH',
  NUMBER_OF_PADS = 'NUMBER_OF_PADS',
  PROPERTY_CONDITION = 'PROPERTY_CONDITION',
  BUILDING_WINTERIZED_YN = 'BUILDING_WINTERIZED_YN',
  BUILDOUT_ALLOWANCE_YN = 'BUILDOUT_ALLOWANCE_YN',
  ABOVE_GRADE_UNFINISHED_AREA = 'ABOVE_GRADE_UNFINISHED_AREA',
  ABOVE_GRADE_UNFINISHED_AREA_SOURCE = 'ABOVE_GRADE_UNFINISHED_AREA_SOURCE',
  ABOVE_GRADE_UNFINISHED_AREA_UNITS = 'ABOVE_GRADE_UNFINISHED_AREA_UNITS',
  BASEMENT_FINISHED_PERCENT = 'BASEMENT_FINISHED_PERCENT',
  BASEMENT_FOOTPRINT_PERCENT = 'BASEMENT_FOOTPRINT_PERCENT',
  BELOW_GRADE_UNFINISHED_AREA = 'BELOW_GRADE_UNFINISHED_AREA',
  CONTIGUOUS_SQUARE_FEET_AVAILABLE_YN = 'CONTIGUOUS_SQUARE_FEET_AVAILABLE_YN',
  BELOW_GRADE_UNFINISHED_AREA_SOURCE = 'BELOW_GRADE_UNFINISHED_AREA_SOURCE',
  BELOW_GRADE_UNFINISHED_AREA_UNITS = 'BELOW_GRADE_UNFINISHED_AREA_UNITS',
  COOLING_FUEL = 'COOLING_FUEL',
  ELEVATORS = 'ELEVATORS',
  TOTAL_LOADING_DOCKS = 'TOTAL_LOADING_DOCKS',
  TOTAL_LEVELERS = 'TOTAL_LEVELERS',
  TOTAL_DRIVE_IN_DOORS = 'TOTAL_DRIVE_IN_DOORS',
  HEATING_FUEL = 'HEATING_FUEL',
  HOT_WATER = 'HOT_WATER',
  OTHER_UNITS = 'OTHER_UNITS',
  PARKING_SPACE_NUMBER = 'PARKING_SPACE_NUMBER',
  STORY_LIST = 'STORY_LIST',
  APPROXIMATE_OFFICE_SQUARE_FEET = 'APPROXIMATE_OFFICE_SQUARE_FEET',
  APPROXIMATE_RETAIL_SQUARE_FEET = 'APPROXIMATE_RETAIL_SQUARE_FEET',
  APPROXIMATE_WAREHOUSE_SQUARE_FEET = 'APPROXIMATE_WAREHOUSE_SQUARE_FEET',
  CLEAR_SPAN_CEILING_HEIGHT = 'CLEAR_SPAN_CEILING_HEIGHT',
  DRIVE_IN_DOOR_HEIGHT = 'DRIVE_IN_DOOR_HEIGHT',
  NET_SQUARE_FEET = 'NET_SQUARE_FEET',
  NUMBER_OF_OVERHEAD_DOORS = 'NUMBER_OF_OVERHEAD_DOORS',
  TOTAL_RESTROOMS = 'TOTAL_RESTROOMS',
  UNIT_WASHER_DRYER_HOOKUP_YN = 'UNIT_WASHER_DRYER_HOOKUP_YN',
  CENTRAL_AIR_YN = 'CENTRAL_AIR_YN',
  UPPER_LEVEL_1_BEDROOMS = 'UPPER_LEVEL_1_BEDROOMS',
  UPPER_LEVEL_1_FULL_BATHS = 'UPPER_LEVEL_1_FULL_BATHS',
  UPPER_LEVEL_1_HALF_BATHS = 'UPPER_LEVEL_1_HALF_BATHS',
  UPPER_LEVEL_1_TOTAL_BATHS = 'UPPER_LEVEL_1_TOTAL_BATHS',
  UPPER_LEVEL_2_BEDROOMS = 'UPPER_LEVEL_2_BEDROOMS',
  UPPER_LEVEL_2_FULL_BATHS = 'UPPER_LEVEL_2_FULL_BATHS',
  UPPER_LEVEL_2_HALF_BATHS = 'UPPER_LEVEL_2_HALF_BATHS',
  UPPER_LEVEL_2_TOTAL_BATHS = 'UPPER_LEVEL_2_TOTAL_BATHS',
  UPPER_LEVEL_3_BEDROOMS = 'UPPER_LEVEL_3_BEDROOMS',
  UPPER_LEVEL_3_FULL_BATHS = 'UPPER_LEVEL_3_FULL_BATHS',
  UPPER_LEVEL_3_HALF_BATHS = 'UPPER_LEVEL_3_HALF_BATHS',
  UPPER_LEVEL_3_TOTAL_BATHS = 'UPPER_LEVEL_3_TOTAL_BATHS',
  UPPER_LEVEL_4_BEDROOMS = 'UPPER_LEVEL_4_BEDROOMS',
  UPPER_LEVEL_4_FULL_BATHS = 'UPPER_LEVEL_4_FULL_BATHS',
  UPPER_LEVEL_4_HALF_BATHS = 'UPPER_LEVEL_4_HALF_BATHS',
  UPPER_LEVEL_4_TOTAL_BATHS = 'UPPER_LEVEL_4_TOTAL_BATHS',
  UPPER_LEVEL_5_BEDROOMS = 'UPPER_LEVEL_5_BEDROOMS',
  UPPER_LEVEL_5_FULL_BATHS = 'UPPER_LEVEL_5_FULL_BATHS',
  UPPER_LEVEL_5_HALF_BATHS = 'UPPER_LEVEL_5_HALF_BATHS',
  UPPER_LEVEL_5_TOTAL_BATHS = 'UPPER_LEVEL_5_TOTAL_BATHS',
  UPPER_LEVEL_6_BEDROOMS = 'UPPER_LEVEL_6_BEDROOMS',
  UPPER_LEVEL_6_FULL_BATHS = 'UPPER_LEVEL_6_FULL_BATHS',
  UPPER_LEVEL_6_HALF_BATHS = 'UPPER_LEVEL_6_HALF_BATHS',
  UPPER_LEVEL_6_TOTAL_BATHS = 'UPPER_LEVEL_6_TOTAL_BATHS',
  LOWER_LEVEL_1_BEDROOMS = 'LOWER_LEVEL_1_BEDROOMS',
  LOWER_LEVEL_1_FULL_BATHS = 'LOWER_LEVEL_1_FULL_BATHS',
  LOWER_LEVEL_1_TOTAL_BATHS = 'LOWER_LEVEL_1_TOTAL_BATHS',
  LOWER_LEVEL_2_BEDROOMS = 'LOWER_LEVEL_2_BEDROOMS',
  LOWER_LEVEL_2_FULL_BATHS = 'LOWER_LEVEL_2_FULL_BATHS',
  LOWER_LEVEL_2_HALF_BATHS = 'LOWER_LEVEL_2_HALF_BATHS',
  LOWER_LEVEL_2_TOTAL_BATHS = 'LOWER_LEVEL_2_TOTAL_BATHS',
  LOWER_LEVEL_3_BEDROOMS = 'LOWER_LEVEL_3_BEDROOMS',
  LOWER_LEVEL_3_FULL_BATHS = 'LOWER_LEVEL_3_FULL_BATHS',
  LOWER_LEVEL_3_HALF_BATHS = 'LOWER_LEVEL_3_HALF_BATHS',
  LOWER_LEVEL_3_TOTAL_BATHS = 'LOWER_LEVEL_3_TOTAL_BATHS',
  LOWER_LEVEL_1_HALF_BATHS = 'LOWER_LEVEL_1_HALF_BATHS',
  LOWER_LEVEL_4_BEDROOMS = 'LOWER_LEVEL_4_BEDROOMS',
  LOWER_LEVEL_4_FULL_BATHS = 'LOWER_LEVEL_4_FULL_BATHS',
  LOWER_LEVEL_4_HALF_BATHS = 'LOWER_LEVEL_4_HALF_BATHS',
  LOWER_LEVEL_4_TOTAL_BATHS = 'LOWER_LEVEL_4_TOTAL_BATHS',
  LOWER_LEVEL_5_BEDROOMS = 'LOWER_LEVEL_5_BEDROOMS',
  LOWER_LEVEL_5_FULL_BATHS = 'LOWER_LEVEL_5_FULL_BATHS',
  LOWER_LEVEL_5_HALF_BATHS = 'LOWER_LEVEL_5_HALF_BATHS',
  LOWER_LEVEL_5_TOTAL_BATHS = 'LOWER_LEVEL_5_TOTAL_BATHS',
  LOWER_LEVEL_6_BEDROOMS = 'LOWER_LEVEL_6_BEDROOMS',
  LOWER_LEVEL_6_FULL_BATHS = 'LOWER_LEVEL_6_FULL_BATHS',
  LOWER_LEVEL_6_HALF_BATHS = 'LOWER_LEVEL_6_HALF_BATHS',
  LOWER_LEVEL_6_TOTAL_BATHS = 'LOWER_LEVEL_6_TOTAL_BATHS',
  BARN_FEATURES = 'BARN_FEATURES',
  SEATING_CAPACITY = 'SEATING_CAPACITY',
  UNIT_BUILDING_TYPE = 'UNIT_BUILDING_TYPE',
  GARAGE_SQFT = 'GARAGE_SQFT',
  BELOW_GRADE_AREA_TOTAL = 'BELOW_GRADE_AREA_TOTAL',
  BELOW_GRADE_AREA_TOTAL_SOURCE = 'BELOW_GRADE_AREA_TOTAL_SOURCE',
  AREA_TOTAL = 'AREA_TOTAL',
  AREA_TOTAL_SOURCE = 'AREA_TOTAL_SOURCE',
  OTHER_STRUCTURES_LIST = 'OTHER_STRUCTURES_LIST',
  DESIGNATED_REPRESENTATIVE_YN = 'DESIGNATED_REPRESENTATIVE_YN',
  SALE_INCLUDES = 'SALE_INCLUDES',
  SHORT_SALE = 'SHORT_SALE',
  REAL_ESTATE_OWNED_YN = 'REAL_ESTATE_OWNED_YN',
  SALE_TYPE = 'SALE_TYPE',
  CLOSE_SALE_TERMS = 'CLOSE_SALE_TERMS',
  CLOSED_LEASE_TERMS_MONTHS = 'CLOSED_LEASE_TERMS_MONTHS',
  CLOSE_AUTO_SCHEDULE_YN = 'CLOSE_AUTO_SCHEDULE_YN',
  ADDITIONAL_PARCELS_DESCRIPTION = 'ADDITIONAL_PARCELS_DESCRIPTION',
  ADDITIONAL_PARCELS_YN = 'ADDITIONAL_PARCELS_YN',
  AGRICULTURAL_DISTRICT = 'AGRICULTURAL_DISTRICT',
  AGRICULTURAL_TAX_DUE = 'AGRICULTURAL_TAX_DUE',
  ASSESSMENT_YEAR = 'ASSESSMENT_YEAR',
  CITY_TOWN_TAX = 'CITY_TOWN_TAX',
  CITY_TOWN_TAX_PAYMENT_FREQUENCY = 'CITY_TOWN_TAX_PAYMENT_FREQUENCY',
  COUNTY_TAX = 'COUNTY_TAX',
  COUNTY_TAX_PAYMENT_FREQUENCY = 'COUNTY_TAX_PAYMENT_FREQUENCY',
  TAX_PAGE_NUMBER = 'TAX_PAGE_NUMBER',
  HISTORIC_YN = 'HISTORIC_YN',
  HISTORIC_ID = 'HISTORIC_ID',
  IMPROVEMENT_ASSESSMENT_AMOUNT = 'IMPROVEMENT_ASSESSMENT_AMOUNT',
  LAND_ASSESSMENT_AMOUNT = 'LAND_ASSESSMENT_AMOUNT',
  LAND_USE_CODE = 'LAND_USE_CODE',
  SECTION = 'SECTION',
  SOURCE_TAX_INTERNAL_KEY = 'SOURCE_TAX_INTERNAL_KEY',
  SPECIAL_ASSESSMENT = 'SPECIAL_ASSESSMENT',
  SPECIAL_ASSESSMENT_REMAINING = 'SPECIAL_ASSESSMENT_REMAINING',
  SPECIAL_TAX_ASSESSMENT_PAYMENT_FREQUENCY = 'SPECIAL_TAX_ASSESSMENT_PAYMENT_FREQUENCY',
  TAX_BLOCK = 'TAX_BLOCK',
  TAX_BOOK_NUMBER = 'TAX_BOOK_NUMBER',
  TAX_SUBDIVISION = 'TAX_SUBDIVISION',
  TAX_LOCAL_HISTORICAL_DESIGNATION_NAME = 'TAX_LOCAL_HISTORICAL_DESIGNATION_NAME',
  TAX_LOCAL_HISTORICAL_DESIGNATION_URL = 'TAX_LOCAL_HISTORICAL_DESIGNATION_URL',
  TAX_LOT = 'TAX_LOT',
  TAX_MAP_NUMBER = 'TAX_MAP_NUMBER',
  TAX_NATIONAL_HISTORICAL_DESIGNATION_NAME = 'TAX_NATIONAL_HISTORICAL_DESIGNATION_NAME',
  TAX_NATIONAL_HISTORICAL_DESIGNATION_URL = 'TAX_NATIONAL_HISTORICAL_DESIGNATION_URL',
  TAX_OTHER_ANNUAL_ASSESSMENT_AMOUNT = 'TAX_OTHER_ANNUAL_ASSESSMENT_AMOUNT',
  PARCEL_ID = 'PARCEL_ID',
  TAX_TOTAL_LIVING_AREA = 'TAX_TOTAL_LIVING_AREA',
  TAX_TOTAL_FINISHED_SQ_FT = 'TAX_TOTAL_FINISHED_SQ_FT',
  ZONING = 'ZONING',
  ZONING_DESCRIPTION = 'ZONING_DESCRIPTION',
  LISTING_TAX_ID = 'LISTING_TAX_ID',
  AUTO_UPDATE_TAX_DATA_YN = 'AUTO_UPDATE_TAX_DATA_YN',
  TAX_DATA_UPDATED_YN = 'TAX_DATA_UPDATED_YN',
  TAX_PHASE = 'TAX_PHASE',
  SCHOOL_TAX = 'SCHOOL_TAX',
  SCHOOL_TAX_PAYMENT_FREQUENCY = 'SCHOOL_TAX_PAYMENT_FREQUENCY',
  LEASABLE_AREA_ANNUAL_TAX = 'LEASABLE_AREA_ANNUAL_TAX',
  TAXES_PER_SQUARE_FEET = 'TAXES_PER_SQUARE_FEET',
  TAX_OPPORTUNITY_ZONE_YN = 'TAX_OPPORTUNITY_ZONE_YN',
  ELECTION_DISTRICT = 'ELECTION_DISTRICT',
  FEDERAL_FLOOD_INSURANCE = 'FEDERAL_FLOOD_INSURANCE',
  FEDERAL_FLOOD_ZONE_YN = 'FEDERAL_FLOOD_ZONE_YN',
  FEDERAL_FLOOD_ZONE = 'FEDERAL_FLOOD_ZONE',
  FRONTAGE_LENGTH = 'FRONTAGE_LENGTH',
  FRONTAGE_TYPE = 'FRONTAGE_TYPE',
  FURNISHED = 'FURNISHED',
  FURNITURE_REPLACEMENT_EXPENSE = 'FURNITURE_REPLACEMENT_EXPENSE',
  HORSE_AMENITIES = 'HORSE_AMENITIES',
  HORSE_YN = 'HORSE_YN',
  LAND_LEASE_AMOUNT = 'LAND_LEASE_AMOUNT',
  LAND_LEASE_AMOUNT_FREQUENCY = 'LAND_LEASE_AMOUNT_FREQUENCY',
  LEASE_IN_EFFECT = 'LEASE_IN_EFFECT',
  MIN_LEASE = 'MIN_LEASE',
  MAX_LEASE = 'MAX_LEASE',
  LICENSES_EXPENSE = 'LICENSES_EXPENSE',
  LOT_DIMENSIONS_SOURCE = 'LOT_DIMENSIONS_SOURCE',
  NUMBER_OF_BUILDINGS = 'NUMBER_OF_BUILDINGS',
  NUMBER_OF_LOTS = 'NUMBER_OF_LOTS',
  NUMBER_OF_UNITS_TOTAL = 'NUMBER_OF_UNITS_TOTAL',
  OTHER_EXPENSE = 'OTHER_EXPENSE',
  PARK_MANAGER_NAME = 'PARK_MANAGER_NAME',
  PARK_MANAGER_PHONE = 'PARK_MANAGER_PHONE',
  PARK_NAME = 'PARK_NAME',
  PEST_CONTROL_EXPENSE = 'PEST_CONTROL_EXPENSE',
  ACCESS_TO_POOL_YN = 'ACCESS_TO_POOL_YN',
  POOL = 'POOL',
  COMMUNITY_POOL_FEATURES = 'COMMUNITY_POOL_FEATURES',
  PROFESSIONAL_MANAGEMENT_EXPENSE = 'PROFESSIONAL_MANAGEMENT_EXPENSE',
  ROAD_RESPONSIBILITY = 'ROAD_RESPONSIBILITY',
  ROAD_FRONTAGE_LENGTH = 'ROAD_FRONTAGE_LENGTH',
  ROAD_SURFACE_TYPE = 'ROAD_SURFACE_TYPE',
  SENIOR_COMMUNITY_AGE_REQUIREMENT = 'SENIOR_COMMUNITY_AGE_REQUIREMENT',
  SENIOR_COMMUNITY_YN = 'SENIOR_COMMUNITY_YN',
  TOPOGRAPHY_LIST = 'TOPOGRAPHY_LIST',
  TRASH_EXPENSE = 'TRASH_EXPENSE',
  WOODED_AREA = 'WOODED_AREA',
  LAUNDRY_TYPE = 'LAUNDRY_TYPE',
  PURCHASE_OPTIONAL_YN = 'PURCHASE_OPTIONAL_YN',
  PERC_SITES = 'PERC_SITES',
  STORAGE = 'STORAGE',
  BUILDING_PERMITS = 'BUILDING_PERMITS',
  BUILDING_SITES = 'BUILDING_SITES',
  PERC_TYPE = 'PERC_TYPE',
  TRANSFER_DEVELOPMENT_RIGHTS = 'TRANSFER_DEVELOPMENT_RIGHTS',
  DOCK_ANNUAL_FEE = 'DOCK_ANNUAL_FEE',
  EXTERIOR_AMENITIES = 'EXTERIOR_AMENITIES',
  GREEN_REMARKS = 'GREEN_REMARKS',
  LOSS_MITIGATION_FEE = 'LOSS_MITIGATION_FEE',
  CLEAN_GREEN_ASSESSED_YN = 'CLEAN_GREEN_ASSESSED_YN',
  WELL_DEPTH = 'WELL_DEPTH',
  TOPOGRAPHY = 'TOPOGRAPHY',
  ASSOCIATION_EXPENSE = 'ASSOCIATION_EXPENSE',
  LOT_SIZE_DESCRIPTION = 'LOT_SIZE_DESCRIPTION',
  POULTRY_FARM_FEATURES = 'POULTRY_FARM_FEATURES',
  DOCK_TYPE_AND_FEATURES = 'DOCK_TYPE_AND_FEATURES',
  DOCK_SLIP_CONVEYANCE_MULTI = 'DOCK_SLIP_CONVEYANCE_MULTI',
  TIDAL_WATER_YN = 'TIDAL_WATER_YN',
  FARM_LAND_PRESERVATION_YN = 'FARM_LAND_PRESERVATION_YN',
  REPAIR_DEDUCTIBLE = 'REPAIR_DEDUCTIBLE',
  MONTHS_RENT_UPFRONT = 'MONTHS_RENT_UPFRONT',
  PROPERTY_USE = 'PROPERTY_USE',
  TENANCY_SVO = 'TENANCY_SVO',
  ALLOW_ONLINE_APPLICATION_YN = 'ALLOW_ONLINE_APPLICATION_YN',
  LEASE_LINK_URL = 'LEASE_LINK_URL',
  DOCKS = 'DOCKS',
  LOCATION_TYPE = 'LOCATION_TYPE',
  OTHER_EQUIPMENT = 'OTHER_EQUIPMENT',
  R_FACTOR_BASEMENT = 'R_FACTOR_BASEMENT',
  R_FACTOR_CEILINGS = 'R_FACTOR_CEILINGS',
  R_FACTOR_WALLS = 'R_FACTOR_WALLS',
  SECURITY_FEATURES = 'SECURITY_FEATURES',
  MEAN_LOW_WATER_FEET = 'MEAN_LOW_WATER_FEET',
  OCCUPANT_NAME = 'OCCUPANT_NAME',
  OCCUPANT_PHONE = 'OCCUPANT_PHONE',
  OCCUPANT_TYPE = 'OCCUPANT_TYPE',
  OWNER_NAME = 'OWNER_NAME',
  OWNER_PHONE = 'OWNER_PHONE',
  OWNER_NAME_BY_TAX = 'OWNER_NAME_BY_TAX',
  OWNER_1_NAME = 'OWNER_1_NAME',
  OWNER_1_EMAIL = 'OWNER_1_EMAIL',
  OWNER_1_MOBILE_PHONE = 'OWNER_1_MOBILE_PHONE',
  OWNER_2_NAME = 'OWNER_2_NAME',
  OWNER_2_EMAIL = 'OWNER_2_EMAIL',
  OWNER_2_MOBILE_PHONE = 'OWNER_2_MOBILE_PHONE',
  OWNER_1_VIEWED_DATE = 'OWNER_1_VIEWED_DATE',
  OWNER_2_VIEWED_DATE = 'OWNER_2_VIEWED_DATE',
  ELECTRIC_AVERAGE_MONTHLY = 'ELECTRIC_AVERAGE_MONTHLY',
  ELECTRIC_LAST_12_MONTHS = 'ELECTRIC_LAST_12_MONTHS',
  GAS_AVERAGE_MONTHLY = 'GAS_AVERAGE_MONTHLY',
  GAS_LAST_12_MONTHS = 'GAS_LAST_12_MONTHS',
  HEATING_OIL_AVERAGE_MONTHLY = 'HEATING_OIL_AVERAGE_MONTHLY',
  HEATING_OIL_LAST_12_MONTHS = 'HEATING_OIL_LAST_12_MONTHS',
  WATER_AVERAGE_MONTHLY = 'WATER_AVERAGE_MONTHLY',
  WATER_LAST_12_MONTHS = 'WATER_LAST_12_MONTHS',
  INTERNET_SERVICES = 'INTERNET_SERVICES',
  SHOWING_CONTACT_PHONE = 'SHOWING_CONTACT_PHONE',
  SHOWING_REQUIREMENTS = 'SHOWING_REQUIREMENTS',
  SHOWING_CONTACT_NAME = 'SHOWING_CONTACT_NAME',
  SHOWING_REPRESENTATIVE_TYPE = 'SHOWING_REPRESENTATIVE_TYPE',
  SHOWING_DAYS = 'SHOWING_DAYS',
  SHOWING_TIME_CLOSE = 'SHOWING_TIME_CLOSE',
  SHOWING_TIME_OPEN = 'SHOWING_TIME_OPEN',
  SHOWING_METHOD = 'SHOWING_METHOD',
  SUB_AGENCY_COMPENSATION_REMARKS = 'SUB_AGENCY_COMPENSATION_REMARKS',
  BUYER_AGENCY_COMPENSATION_REMARKS = 'BUYER_AGENCY_COMPENSATION_REMARKS',
  TRANSACTION_BROKER_COMPENSATION_REMARKS = 'TRANSACTION_BROKER_COMPENSATION_REMARKS',
  FINANCIAL_DATA_SOURCE = 'FINANCIAL_DATA_SOURCE',
  EXISTING_LEASE_TYPE = 'EXISTING_LEASE_TYPE',
  NUMBER_OF_UNITS_MO_MO = 'NUMBER_OF_UNITS_MO_MO',
  OPERATING_EXPENSE_INCLUDES = 'OPERATING_EXPENSE_INCLUDES',
  UNITS_FURNISHED = 'UNITS_FURNISHED',
  FINAL_LEASE_TYPE = 'FINAL_LEASE_TYPE',
  FUEL_EXPENSE = 'FUEL_EXPENSE',
  FRONT_FOOT_FEE = 'FRONT_FOOT_FEE',
  FRONT_FOOT_FEE_PAYMENT_FREQUENCY = 'FRONT_FOOT_FEE_PAYMENT_FREQUENCY',
  INCOME_EXPENSE_LIST = 'INCOME_EXPENSE_LIST',
  INVESTOR_RATIO = 'INVESTOR_RATIO',
  MUNICIPAL_TRASH_YN = 'MUNICIPAL_TRASH_YN',
  REFUSE_FEE = 'REFUSE_FEE',
  WATER_SEWER_HOOKUP_FEE = 'WATER_SEWER_HOOKUP_FEE',
  ANNUAL_GROSS_EXPENSE = 'ANNUAL_GROSS_EXPENSE',
  ANNUAL_HEATING_EXPENSE = 'ANNUAL_HEATING_EXPENSE',
  LAND_LEASE_YEARS_REMAINING = 'LAND_LEASE_YEARS_REMAINING',
  LEASE_RENEWAL_OPTION_YN = 'LEASE_RENEWAL_OPTION_YN',
  PARTICIPANTS = 'PARTICIPANTS',
  TAX_ID = 'TAX_ID',
  VISIBLE_WHEN_OFF_MARKET_MEDIA_KEYS = 'VISIBLE_WHEN_OFF_MARKET_MEDIA_KEYS',
  AUTOMATICALLY_HIDE_MEDIA_OFF_MARKET_YN = 'AUTOMATICALLY_HIDE_MEDIA_OFF_MARKET_YN',
}

export interface FieldDefinition {
  MinLength?: string | null | undefined;
  MaxLength?: string | null | undefined;
  DataType: 'Long' | 'DateTime' | 'Decimal' | string;
  Required?: boolean | undefined;
  Searchable?: boolean | undefined;
  MinValue?: string | null | undefined;
  SearchHelp?: string | null | undefined;
  EditMask?: string | null | undefined;
  MaxValue?: string | null | undefined;
  Scale?: number | null | undefined;
  Precision?: number | null | undefined;
}
